import { CASHFREE_MESSAGE_MAP, CASHFREE_PAYMENT_STATUS, COLUMN_CODES, COMPONENT_TYPE, CONSTANTS, DEFAULT_US_FORMS, DOCUMENT_STATUS_MAP, EMPLOYEE_FILTER, FORMAT, IT_DECLARE_STATUS, payDayTwicePerMonthDays, PAYMENT_MAP, PAYMENT_MAP_US, payPeriod, WEEKDAYS_MAP, workWeek,ITEMS_TO_SKIP_CONTRIBUTION, FILE_TYPE, PERIOD_MAP } from "../../constants/Constant";
import { COLUMN_CODE, TABLES } from "../../managers/TableManger";
import moment from 'moment';
import { DATE_FORMAT } from "../../constants/Constant";
import {
  getUserProfilePic,
  getIncompleteFieldName,
  getCompensationStringType,
  isIndiaCompliance,
  isEffectiveSalaryApplied,
  isUSCompliance,
  isMYCompliance,
  isSGCompliance,
  getTenantCountryCode,
  isRehireEnable,
  convertCamelCaseToWord,
  getInfoIconWithTooltip,
  reverseTimezoneOffset,
  extractTextFromHTML,
  stringSanitizer,
} from "../../managers/common/CommonUtil";
import {PayrollManager} from "../../../src/managers/PayrollManager";
import ic_info_error from "../../assets/icons/ic_info_error.svg";
import ic_info_blue from "../../assets/icons/ic_info_blue.svg";
import ic_info_warning from "../../assets/icons/ic_info_warning.svg";
import {IMP_FIELDS, LOG_MAP} from "../../constants/Constant";
import { INVESTMENT_STAGE } from "../compliance/in/investment/InvestmentConstants";
import {
    DKIcons,
    INPUT_TYPE,
    DKTooltipWrapper,
    DKButton
} from 'deskera-ui-library';
import Utility, { deepClone } from "../../utility/Utility";
import ic_visibility from "../../assets/icons/white/ic_visibility.png";
import ic_autorenew from "../../assets/icons/white/ic_autorenew.png";
import FormatCurrencyService from "../../services/FormatCurrencyService";
import ic_file_green from "../../assets/FilesIcons/file_green.svg";
import ic_file_blue from "../../assets/FilesIcons/file_blue.svg";
import ic_file_red from "../../assets/FilesIcons/file_red.svg";
import TenantManager from "../../managers/TenantManager";
import ic_upload from "../../assets/icons/ic_upload.png";
import ic_check_mark from "../../assets/icons/ic_check_mark.png";
import ic_close from "../../assets/icons/ic_close.png";
import ic_copy from "../../assets/icons/ic_copy.png";
import ic_printer from "../../assets/icons/ic_printer.png";
import ic_delete from "../../assets/icons/ic_delete.png";
import ic_save from "../../assets/icons/ic_save.png";
import { EXPENSE_CONSTANTS } from "../../services/ExpenseClaimListService";
import ic_replay from "../../assets/icons/ic_replay.svg";
import i18next from "i18next";
import MaskInputUtil from "../../SharedComponents/MaskInput/MaskInputUtil";
import ic_credit_card from "../../assets/icons/ic_credit_card.png"
import { COUNTRY } from "../../constants/CountryConstant";
import ShiftUtils from "../shift_management/ShiftUtils";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import ApiConstants from "../../constants/ApiConstants";
import { FORMULA } from "../Component/ComponentConstants";
import ic_info_gray from "../../assets/icons/ic_info_gray.svg";
import EmployeeListService from "../../services/EmployeeListService";
import { SHOW_MINIMUM_NO_LIST } from "../overtime/OvertimeConstants";
import { COMP_OFF_REQUEST_FILTER } from "../compensatoryOff/CompOffConstants";
import ic_download from "../../assets/icons/ic_download.png";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
import { EXPENSE_CLAIM_STATUS, EXPENSE_CLAIM_VIEW_STATUS } from "../expense/ExpenseCommon";


export function PayrollColumnConfig(payrollList, isCashfreeEnabled, functionConfig,filterUpcoming, tenantDetails, customFields, module) {
    let index = filterUpcoming.findIndex(res=>((!res.isPayrunReverted)));
    const { isLocationActive, locationLabel } = getLocationValueAndLabel(tenantDetails);
    let upcomingId;
    if(index != -1) {
        upcomingId=filterUpcoming[index]._id
    }
    let rowData = [];
    if (payrollList && payrollList.length > 0) {
        payrollList.forEach((payroll, index) => {
            let row = {
                [COLUMN_CODE.PAYROLL.PAYDATE]: ((upcomingId==payroll._id)&& isUSCompliance())? getPayDate(payroll,false):Utility.formatDate(payroll.payDate, FORMAT.MMDDYYYY_2),
                [COLUMN_CODE.PAYROLL.WORK_PERIOD]: `${Utility.formatDate(payroll.workPeriod.from, FORMAT.MMDDYYYY_2)} - ${Utility.formatDate(payroll.workPeriod.to, FORMAT.MMDDYYYY_2)}`,
                [COLUMN_CODE.PAYROLL.TOTAL_EARNINGS]: FormatCurrencyService.format(payroll.totalEarnings),
                [COLUMN_CODE.PAYROLL.EMPLOYER_COST]: FormatCurrencyService.format(payroll.totalCost - payroll.totalEarnings),
                [COLUMN_CODE.PAYROLL.TOTAL_COST]: FormatCurrencyService.format(payroll.totalCost ?? 0),
                [COLUMN_CODE.PAYROLL.STATUS]: getPayrollStatus(payroll),
                [COLUMN_CODE.PAYROLL.ID]: payroll._id ? payroll._id : index,
                processed: payroll.processed,
                [COLUMN_CODE.PAYROLL_SUMMARY.PAYMENT_STATUS]: isCashfreeEnabled ? getPaymentStatusForPayrunList(payroll) : (payroll.processed ? CASHFREE_PAYMENT_STATUS.PAID : CASHFREE_PAYMENT_STATUS.PAYMENT_PENDING),
                [COLUMN_CODE.PAYROLL.EMPLOYEES]: payroll.employeeDetails?.length != 0 ? getApplicableEmployeesInPayrun(payroll): "-",
                rowContextMenu:getContextMenuForPayrollGrid(payroll, functionConfig, upcomingId, module),
                ['payrollData']:payroll,
                ['allowToRevertDelete']: (upcomingId==payroll._id) ? getPayDate(payroll,true):false,

            };
            const configData = [
                { key: "location",isActive: isLocationActive,label : locationLabel},
                { key : "custom_field",customFields: customFields}
            ];
            
            row = updateWithExtraColumnConfigsValues(row, payroll, configData);
            rowData.push(row);
        });
    }
    return rowData;
}
export function PayrollRevertFilter(rowData,filterData){
    let index = filterData.findIndex(res=>((!res.isPayrunReverted)&& getPayDate(res,true)))
    if(filterData && filterData.length != 0 && index !=-1) {
        rowData.forEach(row=>{
            if(row['id'] == filterData[0]._id) {
                row['allowToRevertDelete'] = true;
                if(isIndiaCompliance()) {
                    row['payDate'] = Utility.formatDate(row.payrollData.payDate, FORMAT.MMDDYYYY_2)
                }
            } else {
                row['allowToRevertDelete'] = false;
                row['payDate'] = Utility.formatDate(row.payrollData.payDate, FORMAT.MMDDYYYY_2)
            }
        })
    }
    return rowData;
}
export function getPayDate(payroll,CheckAllowToDelete){
    if(getRevertInfoIcon(payroll)) {

        let date = Utility.formatDate(payroll.payDate)
        let msg = `The payrun can be reverted till<br>${getRevertInfoIcon(payroll,true)} to make changes`;
        if(CheckAllowToDelete) {
            return true
        }
        return `<div class="d-flex align-items-center">${Utility.formatDate(payroll.payDate, FORMAT.MMDDYYYY_2)}<span class="ml-s info_error_icon" data-tip="${msg}"><img class="ic-s" style="margin-top:1px;" src= ${ic_info_blue} /></span></div>`
    } else {
        if(CheckAllowToDelete) {
            return false
        }
        return Utility.formatDate(payroll.payDate, FORMAT.MMDDYYYY_2)
    }
}
export function getPayrollStatus(payroll){
    if(payroll.processed) {
        return 'Processed';
    } else if(payroll.isPayrunReverted) {
        let date = Utility.formatDate(moment(payroll.revertedAt), FORMAT.MMDDYYYY_2)
        let msg = `The payrun has been reverted<br>and edited on ${date}`
        return `<div class="d-flex align-items-center">Upcoming<span class="ml-s info_error_icon" data-tip="${msg}"><img class="ic-s" style="margin-top:1px;" src= ${ic_info_blue} /></span></div>`
    } else {
        return 'Upcoming';
    }
}
export function getRevertInfoIcon(row,isTooltip) {
    let isRevertEnabled = false;
    let lastDateToRevert ;
    let inputFormat = DATE_FORMAT.SLASH.MMDDYYYY;
    if (isUSCompliance()&& row && row.processed && row.payDate) {
        let weekoffs = updateWeekoffsData()
        let daysToSubstract = 5;
        let i = 0;
        lastDateToRevert = moment(row.payDate, inputFormat);
        while (i < daysToSubstract) {
            lastDateToRevert = lastDateToRevert.subtract(1, 'days');
            if (weekoffs.some(x => x === lastDateToRevert.get('day'))) {
                daysToSubstract++;
            }
            i++;
        }
        isRevertEnabled = moment().isSameOrBefore(lastDateToRevert);

    }
    if ((isIndiaCompliance() || isSGCompliance()) && row && row.processed && row.payDate) {
        isRevertEnabled = true
    }
    if(!isTooltip) {
        return isRevertEnabled;
    } else {
        return getDateString(moment(lastDateToRevert).format(inputFormat));
    }

}
export function getDateString(dateStr) {
    return Utility.formatDate(dateStr, DATE_FORMAT.SLASH.MMDDYYYY);
}
export function updateWeekoffsData() {
    let tenant = TenantManager.getPeopleTenantData();
    let weekoffs = []
    let workPeriod = tenant['tenant'].workWeekDetails
    const workingoffs = workPeriod.filter(day => !day.isWorkingDay);
    workingoffs.forEach(element => {
        let day = WEEKDAYS_MAP.get(element.day);
        weekoffs.push(day);
    });
    return weekoffs
}

export function getExpeseStatus(exp) {
    
    let expenseApprovalStatus = `<b>Approval Levels</b>`;
    let expense = deepClone(exp);
    
    let approvalLevels = expense['approvalStages'];
    approvalLevels?.forEach((level,index)=>{
        let statusStyle = {} ;
        statusStyle = getStatusStyle(level.levelStatus , statusStyle);
        expenseApprovalStatus += `<p class='m-0'><br/><b>${level.label ? level.label :"Level "+index+1}:</b><span class='${statusStyle['color']} pl-s'><b>${EXPENSE_CLAIM_VIEW_STATUS[level.levelStatus] ? EXPENSE_CLAIM_VIEW_STATUS[level.levelStatus] : EXPENSE_CLAIM_VIEW_STATUS[EXPENSE_CLAIM_STATUS.PENDING] }</b></span></p>`;
        expenseApprovalStatus += `<table><ul>`;
        level.approvers.forEach(approval=>{
            let approvalStyle = {};
            approvalStyle = getStatusStyle(approval.status,approvalStyle)
            expenseApprovalStatus += `<tr style='white-space: nowrap;'><td style='white-space: nowrap;'><li class='ml-m' style='white-space: nowrap;'>${!Utility.isEmpty(approval.name)?approval.name:""}</li></td><td class='${approvalStyle['color']}' style='white-space: nowrap;'> - ${EXPENSE_CLAIM_VIEW_STATUS[approval.status]}</td><td style='white-space: nowrap;'>${approval.approvedAt? " at":""} ${approval.approvedAt ? Utility.formatDate(moment(approval.approvedAt).format(DATE_FORMAT.YYYYMMDD), DATE_FORMAT.YYYYMMDD):""}</td></tr>`;
        })
        expenseApprovalStatus += '</table></ul>';
    }) 
    if(approvalLevels && approvalLevels.length != 0) {
        return `<div class="d-flex align-items-center">${expense.status}<span class="ml-s info_error_icon" data-tip="${expenseApprovalStatus}"><img class="ic-s" style="margin-top:1px;" src= ${ic_info_blue} /></span></div>`
    } else {
        return expense.status
    }
  }

export function getApprovalStatus(approvalStages) {
    if(!approvalStages) {
        return
    }
    const iamUserId = TenantService.get(TENANT.IAM_USER_ID);
    // find ( level st not rejected && approver) if yes save(level,apprObj) else false
    let approvalDetail
    // here need to sort approvalStages
    approvalStages?.sort(function(a, b) {
        return parseFloat(a.level) - parseFloat(b.level);
      });
    approvalStages?.every(stage=>{
        if(stage.levelStatus === EXPENSE_CLAIM_STATUS.REJECTED) {// if rejected for level then no need to proceed. 
            return false
        }
        approvalDetail = stage.approvers.find(approver=> approver.id == iamUserId);
        if(approvalDetail) {
            approvalDetail['status'] = Utility.isEmpty(approvalDetail['status']) ?EXPENSE_CLAIM_STATUS.PENDING : approvalDetail['status'];
            return false;
        }
        if(stage.levelStatus === EXPENSE_CLAIM_STATUS.PENDING && !approvalDetail) { // if pending for lower level then no need to proceed. 
            return false
        }
        return true;
    })
    return approvalDetail;

}
export function getStatusStyle(status,statusStyle={}) {
    switch(status) {
        case EXPENSE_CLAIM_STATUS.APPROVED:
            statusStyle['color'] = "text-app";
            break;
        case EXPENSE_CLAIM_STATUS.PENDING:
            statusStyle['color'] = "text-blue";
            break;
        case EXPENSE_CLAIM_STATUS.REJECTED:
            statusStyle['color'] = "text-red";
            break;
        default:
            statusStyle['color'] = "text-blue";
            
    }
    return statusStyle;
}

export function PayStubColumnConfig(paystubs, mask) {
    let rowData = [];
    if (paystubs && paystubs.length > 0) {
        paystubs.forEach((paystub, index) => {
            const row = {
                [COLUMN_CODE.PAYSTUB.DATE]: Utility.formatDate(paystub.payDate, FORMAT.YYYYMMDD, ""),
                [COLUMN_CODE.PAYSTUB.DAYS]: paystub.days ?? 0,
                [COLUMN_CODE.PAYSTUB.PERIOD]: `${Utility.formatDate(paystub.workPeriod.from, FORMAT.MMDDYYYY_2)} - ${Utility.formatDate(paystub.workPeriod.to, FORMAT.MMDDYYYY_2)}`,
                [COLUMN_CODE.PAYSTUB.VENDOR]: ``,
                [COLUMN_CODE.PAYSTUB.GROSS_PAY]: getMasked(mask, (paystub.basicPayrun ?? 0) + (paystub.earnings ?? 0), paystub.iamUserId),
                [COLUMN_CODE.PAYSTUB.TAXES]: getMasked(mask, (paystub.netTaxes ?? 0), paystub.iamUserId),
                [COLUMN_CODE.PAYSTUB.NET_PAY]: getMasked(mask, (paystub.netPay ?? 0), paystub.iamUserId),
                [COLUMN_CODE.PAYSTUB.AMOUNT_PAID]: getMasked(mask, (paystub.netPay ?? 0), paystub.iamUserId),
                [COLUMN_CODE.PAYSTUB.FILE_PATH]: paystub['filepath'] ?? "",
                [COLUMN_CODE.PAYSTUB.ID]: paystub._id,

            };
            rowData.push(row);
        });
    }
    return rowData;
}

const getDaysLeft = (expiryDate) => {
    var daysLeft = moment(expiryDate,DATE_FORMAT.YYYYMMDD).diff(moment(moment().format(DATE_FORMAT.YYYYMMDD),DATE_FORMAT.YYYYMMDD),'days')
    if (daysLeft > 0) {
        return daysLeft
    }
    return 0
}

export function CompOffRequestColumnConfig(compOffRequests, functionConfig) {
    let rowData = [];
    if (compOffRequests && compOffRequests.length > 0) {
        compOffRequests.forEach((compOffRequest, index) => {
            const row = {
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.EMPLOYEE_NAME]: `${compOffRequest.user.firstName} ${compOffRequest.user.lastName}` ,
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.EMPLOYEE_ID]: compOffRequest.user.employeeId,
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.DAYS_LEFT]: getDaysLeft(compOffRequest.compOffTillDate),
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.WORKING_HOLIDAY]: Utility.formatDate(moment(compOffRequest.compOffDate, CONSTANTS.YYYYMMDD), FORMAT.YYYYMMDD, ""),
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.LEAVE_DATE]: Utility.formatDate(moment(compOffRequest.from, CONSTANTS.YYYYMMDD), FORMAT.YYYYMMDD, ""),
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.DURATION]: compOffRequest.duration,
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.BALANCE]: compOffRequest.balanceDays,
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.REQUEST_STATUS]: compOffRequest.status,
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.ATTACHMENT]: attachmentRenderer(compOffRequest.attachments),
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.DESCRIPTION]: compOffRequest.description,

                rowContextMenu:getContextMenuFroCompOffRequest(compOffRequest, functionConfig),
                ['employeeCompOff']:compOffRequest,
            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function AttendanceColumnConfig(attendanceList, getExpandableView) {
    let rowData = [];
    if (attendanceList && attendanceList.length > 0) {
        attendanceList.forEach((attendance, index) => {
            const row = {
                [COLUMN_CODE.ATTENDANCE.DATE]: Utility.formatDate(attendance.clockIn, FORMAT.YYYYMMDD),
                [COLUMN_CODE.ATTENDANCE.SHIFT]: attendance.shiftName,
                [COLUMN_CODE.ATTENDANCE.CLOCK_IN]: `${getClockInLocationCoordinates(attendance)}`,
                [COLUMN_CODE.ATTENDANCE.CLOCK_OUT]: `${getClockOutLocationCoordinates(attendance)}`,
                [COLUMN_CODE.ATTENDANCE.TOTAL_MINUTES]: getTimeFromMins(Math.abs(attendance.totalMinutes), 'HH:mm'),
                [COLUMN_CODE.ATTENDANCE.TOTAL_MINUTES_BY_PUNCH_LOGS]: getTimeFromMins(Math.abs(attendance.totalMinutesByPunchLogs), 'HH:mm'),
                [COLUMN_CODE.ATTENDANCE.ENTRY]: earlyOrLate(attendance['entryOffsetMinutes'], true),
                [COLUMN_CODE.ATTENDANCE.EXIT]: earlyOrLate(attendance['exitOffsetMinutes'], false),
                [COLUMN_CODE.ATTENDANCE.ID]: attendance.id ? attendance.id : index
            };
            row.expanded = false
            row.punchingLogs = attendance.punchingLogs;
            row.expandableView = getExpandableView(row);
            rowData.push(row);
        });
    }
    return rowData;
}

export function AttendanceDrillDownColumnConfig(punchLogs,functionConfig,parentRowData) {
    let rowData = [];
    if (punchLogs != null && punchLogs.length > 0) {
        punchLogs.forEach((punchLog, index) => {
            const row = {
                [COLUMN_CODE.ATTENDANCE_DRILL_DOWN.PUNCH_DATE]: Utility.formatDate(punchLog.punchAt, FORMAT.YYYYMMDD),
                [COLUMN_CODE.ATTENDANCE_DRILL_DOWN.PUNCH_TIME]: `${getPunchAtLocationCoordinates(punchLog)}`,
                [COLUMN_CODE.ATTENDANCE_DRILL_DOWN.TYPE]: `${punchLog.type === 'CLOCK_IN' ? 'Entry' : 'Exit'}`,
                [COLUMN_CODE.ATTENDANCE_DRILL_DOWN.CLOCK_IN]: Utility.formatDate(punchLog.clockIn, FORMAT.YYYYMMDD),
                [COLUMN_CODE.ATTENDANCE_DRILL_DOWN.REMARK]: punchLog.remark,
                ['data']: punchLog,
                ['allowProxyPunch']: true,
                ['parentRowData']:parentRowData,
                ['attachments']: punchLog.attachments
            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function AttendanceDrillDownColumnName(column) {
    const columnNameMap = {
        [COLUMN_CODE.ATTENDANCE_DRILL_DOWN.PUNCH_DATE]: 'Punch Date',
        [COLUMN_CODE.ATTENDANCE_DRILL_DOWN.PUNCH_TIME]: 'Punch Time',
        [COLUMN_CODE.ATTENDANCE_DRILL_DOWN.TYPE]: 'Type',
        [COLUMN_CODE.ATTENDANCE_DRILL_DOWN.CLOCK_IN]: 'Clock In',
        [COLUMN_CODE.ATTENDANCE_DRILL_DOWN.REMARK]: 'Remark'
    }
    return columnNameMap[column];
}

export function PayrollLiabilityColumnConfig(liabilities) {
    let rowData = [];

    if (liabilities && liabilities.length > 0) {
        liabilities.forEach((list, index) => {
            const row = {
                [COLUMN_CODE.PAYROLL_LIABILITY_REPORT.DISPLAY_NAME]: list.displayName,
                [COLUMN_CODE.PAYROLL_LIABILITY_REPORT.EMPOLYEE_CONTRIBUTION]: FormatCurrencyService.format(list.employeesContribution),
                [COLUMN_CODE.PAYROLL_LIABILITY_REPORT.EMPLOYER_CONTRIBUTION]: FormatCurrencyService.format(list.employerContribution),
                [COLUMN_CODE.PAYROLL_LIABILITY_REPORT.TOTAL]: FormatCurrencyService.format(list.total)
            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function ImportLogColumnConfig(logs,handler) {
    let rowData = [];

    if (logs && logs.length > 0) {
        logs.forEach((log, index) => {
            if(log && !log.totalRecords){
                return;
            }
            else{
            const row = {
                [COLUMN_CODE.PEOPLE_IMPORT_LOG.MODULE]: getModuleColumn(log),
                [COLUMN_CODE.PEOPLE_IMPORT_LOG.FILE_NAME]: getFileName(log.fileName),
                [COLUMN_CODE.PEOPLE_IMPORT_LOG.FILE_TYPE]: log.fileType,
                [COLUMN_CODE.PEOPLE_IMPORT_LOG.IMPORTED_BY]: log.importedBy,
                [COLUMN_CODE.PEOPLE_IMPORT_LOG.IMPORTED_ON]: Utility.formatDate(new Date(log.updatedAt), FORMAT.DDMMYYYY),
                [COLUMN_CODE.PEOPLE_IMPORT_LOG.ORIGINAL_FILE]: getFileIcon(log,'original'),
                [COLUMN_CODE.PEOPLE_IMPORT_LOG.DOWNLOAD]: getFileIcon(log,'download') ,
                rowContextMenu: log.updatedFilePath ?  getContextMenuForImport(log,handler) : false,
                // rowButtons:getContextMenuForImport(log,''),
                ['data']:log
            };
            rowData.push(row);
           }
        });
    }
    return rowData;
}
export function getFileDownload(file) {
    console.log(file)
}
export function getFileIcon(log,path) {
    switch(path) {
        case 'original':
            return `<div class="parent-width justify-content-center d-flex"><img class="justify-content-center cursor-hand" onclick="getFileDownload(log)" src= ${ic_file_blue} /></div>`;
        case 'download':
            if(log.rejectedFilePath) {
                return `<div class="parent-width justify-content-center d-flex"><img class="justify-content-center cursor-hand" onclick="getFileDownload(log)" src= ${ic_file_green} /><img class="justify-content-center cursor-hand" onclick="getFileDownload(log)" src= ${ic_file_red} /></div>`;
            } else if(log.updatedFilePath) {
                return `<div class="parent-width justify-content-center d-flex"><img class="justify-content-center cursor-hand" onclick="getFileDownload(log)" src= ${ic_file_green} /></div>`;
            }
    }
}
export function getModuleColumn(log){

    let totalRecord = (log.totalRecords) ? log.totalRecords : 0;
    let imported = (log.totalRecords) ? (log.totalRecords - (log.rejectedRecords ? log.rejectedRecords:0)) : 0;
    let rejected = log.rejectedRecords ? log.rejectedRecords : 0;
    return `<span class="fw-m">${getModule(log.module)}</span><span class="text-gray"> (Total Records: ${totalRecord} | Imported: ${imported} | Rejected: ${rejected}) </span>`
}
export function getModule(moduleId) {
    switch (moduleId) {
        case "PEOPLE_CANDIDATE":
            return "CANDIDATE";
        case "COMPONENT":
            return "EARNINGS_AND_DEDUCTIONS";
        case "USER":
            return "EMPLOYEE"
        default:
            return moduleId;
    }
}
export function getFileName(url) {
    return url.substring(url.indexOf("_") + 1, url.length);
}

export function SyncRevertJEBooksIntegrationColumnConfig(payruns) {
    let rowData = [];

    if (payruns && payruns.length > 0) {
        payruns.forEach((list, index) => {
            const row = {
                [COLUMN_CODE.SYNC_REVERT_JE_BOOKS_INTE.PAY_PERIOD]: (list.workPeriod && list.workPeriod.from) ? `${list.workPeriod.from ? Utility.formatDate(list.workPeriod.from, DATE_FORMAT.SLASH.MMDDYYYY) : ""} - ${list.workPeriod.to ? Utility.formatDate(list.workPeriod.to, DATE_FORMAT.SLASH.MMDDYYYY) : ""}` : list.workPeriod && list.workPeriod.to ? Utility.formatDate(list.workPeriod.to, DATE_FORMAT.SLASH.MMDDYYYY) : "",
                [COLUMN_CODE.SYNC_REVERT_JE_BOOKS_INTE.TOTAL_PAYROLL_COST]: FormatCurrencyService.format(list.totalCost),
                [COLUMN_CODE.SYNC_REVERT_JE_BOOKS_INTE.NUMBER_OF_EMPLOYEES]: list.employeeCount,
                [COLUMN_CODE.SYNC_REVERT_JE_BOOKS_INTE.DATE_OF_JE]: list.jePostedOn !== Utility.DEFAULT_DATE ? list.jePostedOn : list.payDate,
                [COLUMN_CODE.SYNC_REVERT_JE_BOOKS_INTE.DATE_OF_REVERSAL_JE]: moment().format(),
                'data': list
            };
            rowData.push(row);
        });
    }
    return rowData;
}
const getEffectivePeriod = (employee) => {
    if (employee.isEffectiveSalary) {
        let effectiveCompensationsArray = employee.effectiveCompensations;
        let visibleCompensation = effectiveCompensationsArray.find(x => x.isVisible);
        let isEffectiveSalaryApplicable = isEffectiveSalaryApplied(
            employee.isEffectiveSalary, visibleCompensation
        );
        if (isEffectiveSalaryApplicable) {
            return getCompensationStringType(visibleCompensation.period);
        } else {
            return getCompensationStringType(employee.compensationPeriod)
        }
    } else {
        return getCompensationStringType(employee.compensationPeriod)
    }
}

const getEffectiveCompensation  = (employee) => {
    let compensationAmount = 0;
    if (employee.isEffectiveSalary) {
        let effectiveCompensationsArray = employee.effectiveCompensations;
        let visibleCompensation = effectiveCompensationsArray.find(x => x.isVisible);
        let isEffectiveSalaryApplicable = isEffectiveSalaryApplied(
            employee.isEffectiveSalary, visibleCompensation
        );
        if (isEffectiveSalaryApplicable) {
            compensationAmount = visibleCompensation.compensation;
            if (compensationAmount) {
              if (typeof compensationAmount === CONSTANTS.STRING) {
                compensationAmount = parseFloat(compensationAmount);
              } else if (typeof compensationAmount === INPUT_TYPE.NUMBER) {
                compensationAmount = compensationAmount;
              }
            } else {
              compensationAmount = 0;
            }
            return compensationAmount;
        } else {
            return isIndiaCompliance() ? employee.ctc : employee.compensation
    }
    } else {
        return isIndiaCompliance() ? employee.ctc : employee.compensation
    }
}

function getCashfreeBeneficiaryStatus(employee, isPayrun) {
    let beneficiaryStatus;

    switch (employee.beneficiaryStatus) {
        case "ADDED":
        case "UPDATED":
            beneficiaryStatus = "Added";
            break;
        case "FAILED_TO_ADD":
            beneficiaryStatus = "Failed to Add";
            break;
        default:
            beneficiaryStatus = "Not Added";
            break;
    }

    if (isPayrun) {
        return beneficiaryStatus;
    } else if (employee.beneficiaryStatus === "FAILED_TO_ADD") {
        return `<div class="row fs-m">
            <span class="border-radius-s data-grid-badge-color-10" style="padding: 2px 6px;">${beneficiaryStatus}</span>
            ${employee.beneficiaryReason ? `<span class="ml-s info_error_icon cursor-hand" data-tip="${employee.beneficiaryReason}"><img class="ic-s" src= ${ic_info_error} /></span>` : ""}
        </div>`;
    } else {
        return `<div class="row fs-m">
            <span class="border-radius-s data-grid-badge-color-5" style="padding: 2px 6px;">${beneficiaryStatus}</span>
        </div>`;
    }
}

export function EmployeeColumnConfig(employeeList, scheduleList, isPayrollSetup, isCashfreeEnabled, functionConfig, tenantData, tenantDetails, mask, customFields) {
    let rowData = [];
    const { isLocationActive, locationLabel } = getLocationValueAndLabel(tenantDetails);
    if (employeeList && employeeList.length > 0) {
        employeeList.forEach((employee, index) => {
            let row = {
              [COLUMN_CODE.PEOPLE_EMPLOYEE_LIST.EMPLOYEE_NAME]:
                getUserNameColumnForEmployeeList(
                  employee,
                  isPayrollSetup,
                  isCashfreeEnabled
                ),
              [COLUMN_CODE.PEOPLE_EMPLOYEE_LIST.COMPENSATION]: getCompensation(mask, employee),
              [COLUMN_CODE.PEOPLE_EMPLOYEE_LIST.CTC]: getCompensation(mask, employee),
              [COLUMN_CODE.PEOPLE_EMPLOYEE_LIST.EMPLOYEE_ID]:
                employee.employeeId,
              [COLUMN_CODE.PEOPLE_EMPLOYEE_LIST.FIRST_PAY_DATE]:
                scheduleList && scheduleList.length > 0
                  ? Utility.formatDate(
                      scheduleList[0].firstPayDate,
                      FORMAT.YYYYMMDD
                    )
                  : "",
              [COLUMN_CODE.PEOPLE_EMPLOYEE_LIST.STATUS]:
                getEmpStatus(employee),

              [COLUMN_CODE.PEOPLE_EMPLOYEE_LIST.USER_ID]: employee.userId
                ? employee.userId
                : index,
              [COLUMN_CODE.PEOPLE_EMPLOYEE_LIST.ROLES]: employee.roles
                ? employee.roles
                : [],
              ["cashfreeStatus"]: isCashfreeEnabled ? getCashfreeBeneficiaryStatus(employee, false) : "",
              rowContextMenu: getContextMenuForEmployeeGrid(
                employee,
                functionConfig
              ),
              ['data']:employee
            };
            const configData = [
                { key: "location",isActive: isLocationActive,label : locationLabel},
                { key : "custom_field",customFields: customFields}
            ];
            
            row = updateWithExtraColumnConfigsValuesForEmployeeList(row, employee, configData);
            rowData.push(row);
        });
    }
    return rowData;
}

export function getCompensation(mask, employee) {
    if (employee.iamUserId == TenantService.get(TENANT.IAM_USER_ID)) {
        return `${MaskInputUtil.getMaskedNumber(mask, getEffectiveCompensation(employee))}/${getEffectivePeriod(employee)}`;
    } else {
        if(!mask && (employee.iamUserId != TenantService.get(TENANT.IAM_USER_ID) ) && (!TenantService.get(TENANT.IS_ADMIN) && !TenantService.get(TENANT.IS_OWNER) ) && !PermissionUtils.hasAccess(MODULE.SALARY,[ACTION.VIEW])){
            return PermissionUtils.showMaskedAmount(`${MaskInputUtil.getMaskedNumber(true, getEffectiveCompensation(employee))}/${getEffectivePeriod(employee)}`);
        } else {
            return PermissionUtils.showMaskedAmount(`${MaskInputUtil.getMaskedNumber(mask, getEffectiveCompensation(employee))}/${getEffectivePeriod(employee)}`);
        }
    }
}

export function getMasked(mask, amount, iamUserId, userId) {
    
    if(!mask && 
        (iamUserId ? (iamUserId != TenantService.get(TENANT.IAM_USER_ID)) : userId != TenantService.get(TENANT.USER_ID)) && 
        !TenantService.get(TENANT.IS_ADMIN) && !TenantService.get(TENANT.IS_OWNER) &&
        !PermissionUtils.hasAccess(MODULE.SALARY,[ACTION.VIEW])
    ) {
        return PermissionUtils.showMaskedAmount(`${MaskInputUtil.getMaskedNumber(true, amount)}`);
    } else {
        return PermissionUtils.showMaskedAmount(`${MaskInputUtil.getMaskedNumber(mask, amount)}`);
    }
    
}
export function getEmpStatus(employee) {
    let employeeStatus;
    if (employee.terminationStage) {
        employeeStatus = employee.terminationStage === CONSTANTS.TERMINATION_INITIATED ? CONSTANTS.TERMINATION_INITIATED : CONSTANTS.TERMINATED;
    } else {
        employeeStatus = employee.status;
    }

    const status = EMPLOYEE_FILTER.find(filter => filter.id === employeeStatus);
    if (status) {
        employeeStatus = status.name;
    } else {
        employeeStatus = "";
    }

    if (employeeStatus === "Termination Initiated" || employeeStatus === "Terminated") {
        const fieldName = TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED) ? "Termination Date" : "Date of Termination";
        const tooltip = `${fieldName}: ${Utility.formatDate(employee.dateOfTermination, DATE_FORMAT.YYYYMMDD)}`;
        return `<div class="row">${employeeStatus} ${getInfoIconWithTooltip(tooltip)}</div>`;
    }

    return employeeStatus;
}

export function ComponentColumnConfig(componentList) {
    let rowData = [];
    if (componentList && componentList.length > 0) {
        componentList.forEach((component, index) => {
            const row = {
                [COLUMN_CODE.PEOPLE_COMPONENT.COMPONENT_NAME]: component.name,
                [COLUMN_CODE.PEOPLE_COMPONENT.TYPE]: (component.type == 'EARNING') ? 'Earning': 'Deduction',
                [COLUMN_CODE.PEOPLE_COMPONENT.AMOUNT_TYPE]: component.isFormula ? FORMULA : (component.isVariable ? 'Variable':'Fixed'),
                [COLUMN_CODE.PEOPLE_COMPONENT.EPF]: (component.compliance&&component.compliance.pf) ? 'Yes': 'No',
                [COLUMN_CODE.PEOPLE_COMPONENT.ESI]:(component.compliance && component.compliance.esi) ? 'Yes': 'No',
                [COLUMN_CODE.PEOPLE_COMPONENT.TAX_EXEMPT]:(component.compliance && component.compliance.taxexempt) ? 'Yes': 'No',
                [COLUMN_CODE.PEOPLE_COMPONENT.STATUS]: component.isActive ? ['true']:['false'],
                [COLUMN_CODE.PEOPLE_COMPONENT.DEDUCTION_TYPE]: (component.type === CONSTANTS.DEDUCTION.toUpperCase() && component.compliance && component.compliance.deductionType) ? (component.compliance.deductionType ==='posttaxdeduction' ? 'Post Tax Deduction' : (component.compliance.deductionType ==='pretaxdeduction' ? 'Pre Tax Deduction':'-') ): '-' ,
                ['id']: component.id ? component.id : index,
                ['component']: component
            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function EmployeeTaxColumnConfig(employeeList,stage,functionConfig) {
    let rowData = [];
    if (employeeList && employeeList.length > 0) {
        employeeList.forEach((employee, index) => {
            const row = {
                [COLUMN_CODE.PEOPLE_EMP_TAX_DECLARATION.EMPLOYEE_NAME]: getITEmployeeName(employee),
                [COLUMN_CODE.PEOPLE_EMP_TAX_DECLARATION.SUBMITTED_ON]: employee.submitOn ? Utility.formatDate(employee.submitOn, FORMAT.YYYYMMDD) : "-",
                [COLUMN_CODE.PEOPLE_EMP_TAX_DECLARATION.STATUS]: getITStatus(employee,stage),
                ['id']: employee.userId ? employee.userId : index,
                ['employee']: employee,
                rowContextMenu: getContextMenuForEmployeeTax(employee, stage, functionConfig)
            };
            rowData.push(row);
        });
    }
    return rowData;
}
function getContextMenuForEmployeeTax(employee, stage, functionConfig) {
    let action = [];
    if (employee.status === "SUBMITTED" && functionConfig?.isResetAllowed(stage)) {
        action.push({
            title: "Reset",
            icon: ic_replay,
            onClick: (data) => {
                functionConfig?.deleteIT(data);
            },
        });
    }
    return action
}
export function getITEmployeeName(employee){
    let rejectedItems = (employee && employee.rejectedItems) ? employee.rejectedItems : [];
    let errorIcon = '';

    if(rejectedItems.length!=0){
        let msg = ''
        msg = `<div><span class='fw-m'>Rejected Items</span>:`
        rejectedItems.forEach((m,ind)=>{
            msg= msg +  `<div class='text-align-left'>${ind+1}. ${m}</div>`
        })
        msg= msg +'</div>'
        errorIcon = `<span class="ml-s info_error_icon" data-tip="${msg}"><img class="ic-s" src= ${ic_info_error} /></span>`
    }

    return `<div class="d-flex"> ${employee.employeeName} ${errorIcon} </div>`
}
export function getITStatus(employee,stage){
    let status = (employee.status === "SUBMITTED" || employee.status === "APPROVED") ? (stage === INVESTMENT_STAGE.APPROVED ? [INVESTMENT_STAGE.APPROVED]:[employee.status]) : stage === INVESTMENT_STAGE.APPROVED ? ["APPROVAL_PENDING"] : ["NOT_SUBMITTED"]
    let ind = IT_DECLARE_STATUS.findIndex(res=>res.id==status)
    if(ind != -1) {
        return IT_DECLARE_STATUS[ind].name;
    } else {
        return ''
    }
}
export function teamAttendanceColumnConfig(attendanceList, getExpandableView, cardView) {
    let rowData = [];
    if (attendanceList && attendanceList.length > 0) {
        attendanceList.forEach((attendance, index) => {
            const row = {
                [COLUMN_CODE.ATTENDANCE_TEAM.EMPLOYEE_NAME]: getUserNameColumn(attendance,cardView),
                [COLUMN_CODE.ATTENDANCE_TEAM.SHIFT]: attendance.shiftName,
                [COLUMN_CODE.ATTENDANCE_TEAM.DESIGNATION]: attendance.designation,
                [COLUMN_CODE.ATTENDANCE_TEAM.EMPLOYEE_ID]: attendance.employeeId,
                [COLUMN_CODE.ATTENDANCE_TEAM.CLOCK_IN]: getClockInLocationCoordinates(attendance),
                [COLUMN_CODE.ATTENDANCE_TEAM.CLOCK_OUT]: getClockOutLocationCoordinates(attendance),
                [COLUMN_CODE.ATTENDANCE_TEAM.TOTAL_MINUTES]: getTimeFromMins(Math.abs(attendance.totalMinutes), 'HH:mm'),
                [COLUMN_CODE.ATTENDANCE_TEAM.TOTAL_MINUTES_BY_PUNCH_LOGS]: getTimeFromMins(Math.abs(attendance.totalMinutesByPunchLogs), 'HH:mm'),
                [COLUMN_CODE.ATTENDANCE_TEAM.ENTRY]: ((attendance['entryOffsetMinutes']) ? earlyOrLate(attendance['entryOffsetMinutes'], true) : '00:00'),
                [COLUMN_CODE.ATTENDANCE_TEAM.EXIT]: ((attendance['exitOffsetMinutes']) ? earlyOrLate(attendance['exitOffsetMinutes'], false) : '00:00'),
                [COLUMN_CODE.ATTENDANCE_TEAM.ID]: attendance.id ? attendance.id : index,
                ['data']: attendance
            };
            if(cardView) {
                row['status'] = attendance.status ? [attendance.status.toLowerCase()]:[]
            }
            row.expanded = false;
            row.punchingLogs = attendance.punchingLogs;
            row.expandableView = getExpandableView(row);
            rowData.push(row);
        });
    }
    return rowData;
}


export function PayrollColumnConfigForProcessPayroll(employeePayrollList, isEditEnable, isContractor) {
    let rowData = [];
    let incompleteProfiles = [];
    let isFixedAllowanceNegative = [];
    PayrollManager.otIds = []
    if (!isContractor && employeePayrollList && employeePayrollList.payrolls && employeePayrollList.payrolls.length > 0) {
        employeePayrollList.payrolls.forEach((payroll, index) => {
            const row = {
                [COLUMN_CODE.PROCESS_PAYROLL.EMPLOYEE]: getUserNameInProcessPayroll(payroll),
                [COLUMN_CODE.PROCESS_PAYROLL.OVERTIME]: getOTForProcessPayroll(payroll, isEditEnable),
                [COLUMN_CODE.PROCESS_PAYROLL.LOP]: getLOPForProcessPayroll(payroll, isEditEnable),
                [COLUMN_CODE.PROCESS_PAYROLL.EMPLOYER_CONTRIBUTION]: getEmployerContribution(payroll),
                [COLUMN_CODE.PROCESS_PAYROLL.ADDITIONAL_EARNING]: getAdditionalEarning(payroll),
                [COLUMN_CODE.PROCESS_PAYROLL.DEDUCTION]: getDeduction(payroll),
                [COLUMN_CODE.PROCESS_PAYROLL.NET_PAY]: `<div class="row" style="text-align:right"><span >${FormatCurrencyService.format(payroll.netPay)}</span></div>`,
                [COLUMN_CODE.PAYROLL.ID]: payroll._id ? payroll._id : index,
                [COLUMN_CODE.PROCESS_PAYROLL.PAYRUN_ID]: employeePayrollList._id ? employeePayrollList._id : index,
                [COLUMN_CODE.PROCESS_PAYROLL.EMPLOYEE_NAME]: payroll.firstName + CONSTANTS.EMPTY_STRING_WITH_SPACE + payroll.lastName,
                [COLUMN_CODE.PROCESS_PAYROLL.EMPLOYEE_ID]: payroll.empId
            };
            if (isIndiaCompliance()) {
               const comp = payroll?.components?.find(c => c.name === CONSTANTS.FIXED_ALLOWANCE)
               if (comp?.amount < 0) {
                isFixedAllowanceNegative.push(row);
               }
            }
            if (payroll && payroll.unfilledFields && payroll.unfilledFields.length > 0) {
                incompleteProfiles.push(row);
            }
            rowData.push(row);
        });
    } else if(isContractor && employeePayrollList && employeePayrollList.payrolls && employeePayrollList.payrolls.length > 0) {
        employeePayrollList.payrolls.forEach((payroll, index) => {
            const row = {
                [COLUMN_CODE.PROCESS_PAYROLL.EMPLOYEE]: getUserNameInContractorProcessPayroll(payroll),
                [COLUMN_CODE.PROCESS_PAYROLL.OVERTIME]: payroll.compensationPeriod === CONSTANTS.HOURLY ? getRHForProcessPayroll(payroll, isEditEnable):"",
                [COLUMN_CODE.PROCESS_PAYROLL.ADDITIONAL_EARNING]: getAdditionalEarning(payroll),
                [COLUMN_CODE.PROCESS_PAYROLL.NET_PAY]: `<div class="row" style="text-align:right"><span >${FormatCurrencyService.format(payroll.netPay)}</span></div>`,
                [COLUMN_CODE.PAYROLL.ID]: payroll._id ? payroll._id : index,
                [COLUMN_CODE.PROCESS_PAYROLL.PAYRUN_ID]: employeePayrollList._id ? employeePayrollList._id : index,
                [COLUMN_CODE.PROCESS_PAYROLL.EMPLOYEE_NAME]: payroll.firstName + CONSTANTS.EMPTY_STRING_WITH_SPACE + payroll.lastName,
                [COLUMN_CODE.PROCESS_PAYROLL.DEDUCTION]: getDeduction(payroll)
            };
            rowData.push(row);
        });
    }

    return {rowData, incompleteProfiles, isFixedAllowanceNegative};
}


export function PayScheduleColumnConfig(payScheduleList, tenantDetails, customFields, usersMapValues) {
    let rowData = [];
    const { isLocationActive, locationLabel } = getLocationValueAndLabel(tenantDetails);
    if (payScheduleList && payScheduleList.length > 0) {
        payScheduleList.forEach((paySchedule, index) => {
            let row = {
                [COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_SCHEDULE]: paySchedule.name,
                [COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_PERIOD]: getPayperiod(paySchedule.payPeriod),
                [COLUMN_CODE.PAY_SCHEDULE_LIST.DAY_OF_WEEK]: paySchedule.payPeriod == 'weekly'? getDayOfWeek(paySchedule.payDay):'NA',
                [COLUMN_CODE.PAY_SCHEDULE_LIST.DAY_OF_MONTH]: paySchedule.payPeriod != 'weekly'? getDayOfMonth(paySchedule.payDay):'NA',
                [COLUMN_CODE.PAY_SCHEDULE_LIST.DEADLINE_FOR_PAYRUN]: getDeadlineDate(paySchedule.firstPayDate),
                [COLUMN_CODE.PAY_SCHEDULE_LIST.ID]: paySchedule.id,
                // [COLUMN_CODE.PAY_SCHEDULE_LIST.APPLICABLE_TO_USERS]: paySchedule.isForAllUsers ? "All" : getUsersNames(paySchedule.employees, usersMapValues)

            };
            const configData = [
                { key: "location",isActive: isLocationActive,label : locationLabel},
                { key : "custom_field",customFields: customFields}
            ];
            
            row = updateWithExtraColumnConfigsValues(row, paySchedule, configData);
            rowData.push(row);
        });
    }

    return rowData;
}
export function getPayperiod(params) {
    let selectedPayPeriod= payPeriod.filter(res=>{
        if(res.id == params) {
            return res
        }
    })
    return (selectedPayPeriod[0] && selectedPayPeriod[0].name) ? selectedPayPeriod[0].name: ''
}
export function getDayOfWeek(params) {

    let selectedPayPeriod= workWeek.filter(res=>{
        if(res.id == params) {
            return res
        }
    })
    return (selectedPayPeriod[0] && selectedPayPeriod[0].name) ? selectedPayPeriod[0].name: ''
}

export function CustomFieldColumnConfig(customFieldList) {
    let rowData = [];
    if (customFieldList && customFieldList.length > 0) {
        customFieldList.forEach((customField, index) => {
            const row = {
                [COLUMN_CODE.CUSTOM_FIELD_LIST.NAME]: customField.name,
                [COLUMN_CODE.CUSTOM_FIELD_LIST.TYPE]: getCustomeFieldType(customField.type),
                [COLUMN_CODE.CUSTOM_FIELD_LIST.MAX_LENGTH]: getMaxLength(customField),
                [COLUMN_CODE.CUSTOM_FIELD_LIST.DISPLAY_IN]: getModuleList(customField),
                [COLUMN_CODE.CUSTOM_FIELD_LIST.STATUS]: [String(customField.isActive)],
                [COLUMN_CODE.CUSTOM_FIELD_LIST.ID]: customField.id,
                ...customField

            };
            rowData.push(row);
        });
    }

    return rowData;
}

export function ProfessionalTaxReportColumnConfig(ptReport) {
    let rowData = [];
    if (ptReport && ptReport.length > 0) {
        ptReport.forEach((report, index) => {
            const row = {
                [COLUMN_CODE.PROFESSIONAL_TAX_REPORT.EMPLOYEE_ID]: report.employeID,
                [COLUMN_CODE.PROFESSIONAL_TAX_REPORT.EMPLOYEE_NAME]: report.employeeName,
                [COLUMN_CODE.PROFESSIONAL_TAX_REPORT.PT_WAGES]: report.ptWagesAmount,
                [COLUMN_CODE.PROFESSIONAL_TAX_REPORT.PT_AMOUUNT]: report.ptTaxAmount,
                [COLUMN_CODE.PROFESSIONAL_TAX_REPORT.ID]: report.id,
                [COLUMN_CODE.PROFESSIONAL_TAX_REPORT.PT_TAX]: (report.professionalTax ? i18next.t("APPLICABLE"):i18next.t("NOT_APPLICABLE")),

            };
            rowData.push(row);
        });
    }

    return rowData;
}

export function EsiTaxReportColumnConfig(ptReport) {
    let rowData = [];
    if (ptReport && ptReport.length > 0) {
        ptReport.forEach((report, index) => {
            const row = {
                [COLUMN_CODE.PEOPLE_ESI_TAX_REPORT.EMPLOYEE_ID]: report.employeeID,
                [COLUMN_CODE.PEOPLE_ESI_TAX_REPORT.EMPLOYEE_NAME]: report.employeeName,
                [COLUMN_CODE.PEOPLE_ESI_TAX_REPORT.EMPLOYEE_CONTRIBUTION]: report.employeeContribution,
                [COLUMN_CODE.PEOPLE_ESI_TAX_REPORT.EMPLOYER_CONTRIBUTION]: report.employerContribution,
                [COLUMN_CODE.PEOPLE_ESI_TAX_REPORT.ESI_NUMBER]: report.esiNumber,
                [COLUMN_CODE.PEOPLE_ESI_TAX_REPORT.ESI_APPLICABLE]: (report.esiApplicable ? i18next.t("APPLICABLE"):i18next.t("NOT_APPLICABLE")),
                [COLUMN_CODE.PEOPLE_ESI_TAX_REPORT.TOTAL_CONTRIBUTION]: report.totalContribution

            };
            rowData.push(row);
        });
    }

    return rowData;
}

export function EpfTaxReportColumnConfig(ptReport) {
    let rowData = [];
    if (ptReport && ptReport.length > 0) {
        ptReport.forEach((report, index) => {
            const row = {
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.EMPLOYEE_ID]: report.employeID ? report.employeID : (report.employeeID ? report.employeeID:"-"),
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.UAN]: report.uanNumber,
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.EPF_WAGES]: report.epfWages,
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.EPS_WAGES]: report.epsWages,
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.GROSS_WAGES]: report.grossWages,
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.MEMBER_NAME]: report.memberName? report.memberName: (report.employeeName? report.employeeName:""),
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.EDLI_WAGES]: report.edliWages,
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.EPF_CONTRIBUTION_REMITTED]: report.epfContributionRemitted,
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.EPS_CONTRIBUTION_REMITTED]: report.epsContributionRemitted,
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.EPF_AND_EPS_DIFF_REMITTED]: report.epfEpsDiffRemitted,
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.NCP_DAYS]: report.ncpDays,
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.PF]: (report.pf ? i18next.t("APPLICABLE"):i18next.t("NOT_APPLICABLE")),
                [COLUMN_CODE.PEOPLE_EPF_TAX_REPORT.REFUND_OF_ADVANCES]: report.refundOfAdvance

            };
            rowData.push(row);
        });
    }

    return rowData;
}
export function ComponentGroupsColumnConfig(componentGroups) {
    let rowData = [];
    if (componentGroups && componentGroups.length > 0) {
        componentGroups.forEach((componentGroup, index) => {
            const row = {
                [COLUMN_CODE.COMPONENT_GROUP_LIST.NAME]: componentGroup.name,
                [COLUMN_CODE.COMPONENT_GROUP_LIST.ID]: componentGroup.id,
                ['data']:componentGroup

            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function BenefitsColumnConfig(benefitsList) {
    let rowData = [];
    if (benefitsList && benefitsList.length > 0) {
        benefitsList.forEach((benefit, index) => {
            const row = {
                [COLUMN_CODE.BENEFITS_LIST.NAME]: benefit.name,
                [COLUMN_CODE.BENEFITS_LIST.EMPLOYEE_DEDUCTION]: getFieldWithLabelAndAmount(benefit.employeeDeductionType === 'percent' ? "Percent" : "Amount" , benefit.employeeDeductionType === 'percent' ? benefit.employeeDeductionAmount + " %" :benefit.employeeDeductionAmount ),
                [COLUMN_CODE.BENEFITS_LIST.EMPLOYER_DEDUCTION]: getFieldWithLabelAndAmount(benefit.employerDeductionType === 'percent' ? "Percent" : "Amount" , benefit.employerDeductionType === 'percent' ? benefit.employerDeductionAmount + " %" :benefit.employerDeductionAmount ),
                [COLUMN_CODE.BENEFITS_LIST.ANUAL_MAXIMUM_CONTRIBUTION]: benefit.annualMaxContribution,
                [COLUMN_CODE.BENEFITS_LIST.TYPE]: benefit.compliance ? benefit.compliance.deductionType === "posttaxdeduction" ? "Post-Tax" : "Pre-Tax" : "",
                [COLUMN_CODE.BENEFITS_LIST.STATUS]: benefit.isActive ? ["ACTIVE"] : ["INACTIVE"],
                [COLUMN_CODE.BENEFITS_LIST.ID]: benefit.benefitId,
                ['data']:benefit

            };
            rowData.push(row);
        });
    }

    return rowData;
}

export function GiroListColumnConfig(giroList) {
    let rowData = [];
    if (giroList && giroList.length > 0) {
        giroList.forEach((giro, index) => {
            const row = {
                [COLUMN_CODE.PEOPLE_GIRO.PAY_PERIOD]: giro.workPeriod ? (`${ Utility.formatDate(giro.workPeriod.from,FORMAT.MMDDYYYY_2)} - ${Utility.formatDate(giro.workPeriod.to,FORMAT.MMDDYYYY_2)}`):'-',
                [COLUMN_CODE.PEOPLE_GIRO.PAY_SCHEDULE]: giro.paySchedule ? giro.paySchedule.name : '-',
                [COLUMN_CODE.PEOPLE_GIRO.PAY_DATE]: Utility.formatDate(giro.firstPayDate,FORMAT.MMDDYYYY_2),
                [COLUMN_CODE.PEOPLE_GIRO.NET_PAY]: FormatCurrencyService.format(giro.netPay),
                [COLUMN_CODE.PEOPLE_GIRO.EMPLOYEE_GIRO]: (giro.generatedGIROCount + '/' + giro.totalEmployee),
                ['data']:giro

            };
            rowData.push(row);
        });
    }

    return rowData;
}

export function EmployeePaymentListColumnConfig(employeeList) {
    let rowData = [];
    if (employeeList && employeeList.length > 0) {
        employeeList.forEach((employee, index) => {
            const row = {
                [COLUMN_CODE.PEOPLE_GIRO_EMPLOYEE.EMPLOYEE_NAME]: employee.employeeName,
                [COLUMN_CODE.PEOPLE_GIRO_EMPLOYEE.BANK]: getBankName(employee.bank),
                [COLUMN_CODE.PEOPLE_GIRO_EMPLOYEE.PAY_SCHEDULE]: employee.paySchedule ? employee.paySchedule : '-',
                [COLUMN_CODE.PEOPLE_GIRO_EMPLOYEE.PAY_PERIOD]:employee.payPeriodFromDate ? (`${ Utility.formatDate(employee.payPeriodFromDate,FORMAT.MMDDYYYY_2)} - ${Utility.formatDate(employee.payPeriodToDate,FORMAT.MMDDYYYY_2)}`):'-',
                [COLUMN_CODE.PEOPLE_GIRO_EMPLOYEE.NET_PAY]: FormatCurrencyService.format(employee.netPay),
                [COLUMN_CODE.PEOPLE_GIRO_EMPLOYEE.GIRO_GENERATED]:employee.giroGenerated ? [true]:[false],
                [COLUMN_CODE.PEOPLE_GIRO_EMPLOYEE.SALARY_GIRO_GENERATED]: employee?.salaryGiroGenerated ? [true]:[false],
                [COLUMN_CODE.PEOPLE_GIRO_EMPLOYEE.STATUTORY_GIRO_GENERATED]: getStatutoryGiroStatusText(employee),
                ['data']:employee
                
            };
            rowData.push(row);
        });
    }

    return rowData;
}
export function getBankName(bank) {
    switch(bank) {
        case 'mayBank':
            return 'May Bank';
        case 'cimbBank':
            return 'CIMB Bank';
        case 'uobBank':
            return 'UOB Bank';
        case 'rhbBank':
            return 'RHB Bank';
        case 'publicBankBerhad':
            return 'Public Bank Berhad';
        case 'amBank':
            return 'AmBank';
        case 'mayBank2E':
            return 'MayBank(2E)';
        case 'hongLeongBank':
            return 'Hong Leong Bank';
        case 'bankIslam':
            return 'BANK ISLAM';
        default:
            return convertCamelCaseToWord(bank)

    }
}
export function AppliedCompOffDetailRow(rows) {
    let rowData = [];
    if (rows && rows.length > 0) {
        rows.forEach((data, index) => {
            const row = {
                [COLUMN_CODE.PEOPLE_APPLY_COMP_OFF_REQUEST.WORKING_HOLIDAY]: data.compOffDate,
                [COLUMN_CODE.PEOPLE_APPLY_COMP_OFF_REQUEST.BALANCE_DAYS]: (moment(data.compOffTillDate,'YYYY-MM-DD').diff(moment(moment().format('YYYY-MM-DD'),'YYYY-MM-DD'),'days')) >= 0 ? (moment(data.compOffTillDate,'YYYY-MM-DD').diff(moment(moment().format('YYYY-MM-DD'),'YYYY-MM-DD'),'days')):0,
                [COLUMN_CODE.PEOPLE_APPLY_COMP_OFF_REQUEST.LEAVE_DATE]: data.from,
                [COLUMN_CODE.PEOPLE_APPLY_COMP_OFF_REQUEST.DURATION]: data.duration,
                [COLUMN_CODE.PEOPLE_APPLY_COMP_OFF_REQUEST.TOTAL_DAYS_AVAILABLE]: data.balanceDays,
                [COLUMN_CODE.PEOPLE_APPLY_COMP_OFF_REQUEST.ATTACHMENTS]:attachmentRenderer(data.attachments),
                [COLUMN_CODE.PEOPLE_APPLY_COMP_OFF_REQUEST.STATUS]: [data.status],
                [COLUMN_CODE.PEOPLE_APPLY_COMP_OFF_REQUEST.DESCRIPTION]: data.description,
                ['data']:data
            };
            rowData.push(row);
        });
    }
    return rowData;
}
function attachmentRenderer(value, rowIndex) {
    if (value && value[0]) {
        return value.map(v=>`<div onclick="window.downloadCompOffFile(' ${Utility.encodeJSON(v)} ')" class="row" ><img class="cursor-hand" style="width:18px" src= ${Utility.getFileIcon(getFileName(v))} /></div>`)
        
    } else {
        return '-'
    }
};
function getMaxLength (customField) {
    return customField.type === "number" ? customField.decimalPrecision : customField.type === "text" ? customField.maxLength : customField.type === "multiselect" ? "Variable" : ""
}

function getCustomeFieldType(key) {
    return key === "number" ? "Number" : key === "text" ? "Text" : key === "multiselect" ? "Multiple Selection Dropdown Menu" : ""
}

function getDayOfMonth(key){
    if (key === "lastWorkingDayMonth" ) {
        return "Last working day of the month"
    } else if(payDayTwicePerMonthDays[0].id == key) {
        return payDayTwicePerMonthDays[0].name;
    }

    return key

}

function getDeadlineDate(firstPayDate) {
    const payDate = new Date(firstPayDate);
    let deadlineForPayment =  new Date(payDate.setDate(payDate.getDate() - 7));
    return Utility.formatDate(moment(deadlineForPayment).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY);
}


export function parseVisibleColumnConfig(columnData) {
    columnData = columnData?.filter((column) => !column.hidden) || [];
    columnData?.forEach(column => {
        column['key'] = column.columnCode;
    });
    return columnData;
}

export function parseColumnConfig(columnData, tableName, viewConfig) {
  let isContractor = false;
  if(viewConfig) {
    isContractor = tableName === TABLES.PAYSTUB_LIST && viewConfig.isContractor
  }

  columnData?.forEach((column) => {
    column["key"] = column.columnCode;
    if (isIndiaCompliance()) {
      if (column.columnCode === "compensation") {
        column.uiVisible = false;
        column.hidden = true;
        column.name = i18next.t("BASIC_SALARY");
        column.type = 'number';
      } else if (column.columnCode === "ctc") {
        column.uiVisible = true;
        column.hidden = false;
        column.name = i18next.t("BASIC_SALARY");
        column.type = 'number';
      }
    } else {
      if (column.columnCode === "compensation") {
        column.uiVisible = true;
        column.hidden = false;
        column.name = i18next.t("BASIC_SALARY");
        column.type = 'number';
      } else if (column.columnCode === "ctc") {
        column.uiVisible = false;
        column.hidden = true;
        column.name = i18next.t("BASIC_SALARY");
        column.type = 'number';
      }
    }

    switch(column.columnCode) {
        case "pf":
        case "esi":
        case "taxexempt":
          column.uiVisible =  isIndiaCompliance()? true:false;
          column.hidden =  isIndiaCompliance()? false: true;
          break;
        case "deductionType":
          column.uiVisible = isUSCompliance()? true: false;
          column.hidden = isUSCompliance()? false: true;
          break;
        case "overtime":
            column.name = "Overtime (OT x Hrs x Rate = Amount)";
            column.width = 300;
            break;
        case "uniqueId":
            if(getTenantCountryCode() != COUNTRY.US) {
                column.uiVisible = false;
                column.hidden = true;
            }
            break;
        case 'filePath':
        case 'updatedFilePath':
            if(column.name == "Original File" || column.name =="Download") {
                column.hidden = true;
                column.uiVisible = false;
            }
            break;
        case "totalMinutes":
        case "entryOffsetMinutes":
        case "exitOffsetMinutes":
        case "clockIn":
            column.editable = false;
            break;
        case "clockOut":
            column.editable = false;
            break;
        case "designation":
            column.name = "Job Title";
            column.width = 200;
            break;
        case "lop":
            column.name = "Unpaid Days";
            break;
        case "firstPayDate":
            if(tableName==TABLES.EMPLOYEE_LIST) {
                column.allowFilter = false;
                column.allowColumnSort = false;

                if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
                    column.uiVisible = false;
                    column.hidden = true;
                }
            }
            break;
        case "employeeId":
            if(tableName==TABLES.EMPLOYEE_LIST) {
                column.type = 'number';
            } else if (tableName === TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS) {
                column.allowFilter = false
            }
            break;
        case "name":
            if(tableName === TABLES.EMPLOYEE_LIST && TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
                column.width = 450;
            }
            break;
        case "days":
        case "period":
        case "grossPay":
        case "taxes":
        case "netPay":
            column.hidden = isContractor;
            break;
        case "code":
        case "spendDate":
        case "userName":
        case "merchant":
        case "totalAmount":
            if (tableName === TABLES.PEOPLE_EXPENSE_CLAIMS) {
                column.allowFilter = false;
            }
            break;
        case "groupName":
            if (tableName === TABLES.PEOPLE_EXPENSE_CLAIMS) {
                column.allowFilter = true;
                column.type = 'select';
            }
            break;
        case "category":
            if (tableName === TABLES.PEOPLE_EXPENSE_CLAIMS) {
                column.type = "select";
                if (Array.isArray(viewConfig.categories)) {
                    column.options = [{ id: "", name: "All" }, ...viewConfig.categories];
                }
            }
            break;
        case COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.GROUP :
            column.allowFilter = true;
            column.required = true;
            column.editable = true;
            break;
        case COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.CATEGORY_ID:
            column.allowAddOption = false;
            break;
        case COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.TAX_CODE:
            column.allowAddOption = false;
            break;
        case COLUMN_CODE.PEOPLE_PAYMENT_LOGS.BATCH_ID:
            column.uiVisible = isMYCompliance() ? false : true;
            column.hidden = isMYCompliance() ? true : false;
            break;
        case COLUMN_CODE.PEOPLE_CONTRACTOR_LIST.EMAIL_ID:
            if(tableName === TABLES.CONTRACTOR_LIST) {
                column.allowColumnSort = false;
                column.editable = false
            }
            break;
        case COLUMN_CODE.ATTENDANCE.SHIFT:
        case COLUMN_CODE.ATTENDANCE_TEAM.SHIFT:
            column.required = false;
            column.hidden = !TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED);
            column.uiVisible = TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED);
            break;
        case COLUMN_CODE.PEOPLE_GIRO_EMPLOYEE.SALARY_GIRO_GENERATED:
        case COLUMN_CODE.PEOPLE_GIRO_EMPLOYEE.STATUTORY_GIRO_GENERATED:
            switch (getTenantCountryCode()) {
                case COUNTRY.SG:
                    column.hidden =  true;
                    column.required = false;
                    column.uiVisible = false;
                    break;
                case COUNTRY.MY:
                    if(viewConfig?.bankName) {
                        switch (viewConfig?.bankName) {
                            case "BANKISLAM":
                               column.uiVisible = false;
                               column.hidden = true;
                               column.required = false;
                                break;
                            default :
                                column.uiVisible = true;
                                column.hidden = false;
                                column.required = true;
                        }
                    } else {
                        column.uiVisible = true;
                        column.hidden = false;
                        column.required = true;
                    }
            
                default:
                    break;
            }
            if(getTenantCountryCode() === COUNTRY.SG) {
                column.hidden =  true;
                column.required = false;
                column.uiVisible = false;
            }
            break;
        case COLUMN_CODE.PAYROLL.WORK_PERIOD:
        case COLUMN_CODE.PAYROLL.TOTAL_EARNINGS:
        case COLUMN_CODE.PAYROLL.EMPLOYER_COST:
        case COLUMN_CODE.PAYROLL.TOTAL_COST:
        case COLUMN_CODE.PAYROLL.PAYMENT_STATUS:
            column.allowFilter = false;
            break;
        case COLUMN_CODE.PAYROLL.STATUS:
            if (tableName === TABLES.EMPLOYEE_LIST) {
                column.type = 'select';
                column.allowColumnSort = false;
            } 
            if (tableName === TABLES.PEOPLE_EXPENSE_CLAIMS) {
                column.allowFilter = false;
            }
            if(tableName === TABLES.PAYROLL) {
                column.allowFilter = false;
            }
            if(tableName === TABLES.PEOPLE_MANAGE_COMP_OFF) {
                column.allowFilter = false;
            }
            switch(tableName) {
                case TABLES.CUSTOME_FIELD_LIST:
                column.editable = true;
                column.allowAddOption = false;
                break;
                case TABLES.PEOPLE_EXPENSE_CLAIMS:
                    column.width = 120;
                break;
            }
            
            break;
        case COLUMN_CODE.PEOPLE_FORM16.FORM16_STATUS:
            column.name = "Form 16 Status";
            column.options = [{id:"",name:"NA",color:'data-grid-badge-color-2'}, ...column.options];
            break;
        case COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.REQUEST_STATUS: 
            switch (tableName) {
                case TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS :
                    column.type = 'select'
                    column.options = COMP_OFF_REQUEST_FILTER
                    column.allowFilter = true
                    break
            }
            break
        case  COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.EMPLOYEE_NAME:
        case  COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.DAYS_LEFT:
        case  COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.LEAVE_DATE:       
        case  COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.DURATION:
        case  COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.BALANCE: 
        case  COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF_REQUESTS.ATTACHMENT:
            column.allowFilter = false
            break
        case COLUMN_CODE.PAYROLL.PAYDATE:
            column.width = 180;
            column.allowFilter = false;
            break;
        case COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_SCHEDULE:
        case COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_PERIOD:
        case COLUMN_CODE.PAY_SCHEDULE_LIST.DAY_OF_WEEK:
        case COLUMN_CODE.PAY_SCHEDULE_LIST.DAY_OF_MONTH:
            column.allowFilter = false;    
            break;
        case COLUMN_CODE.PAY_SCHEDULE_LIST.DEADLINE_FOR_PAYRUN:
            column.allowFilter = false;
            column.uiVisible = false;
            column.hidden = true;
            break;
        case COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.NAME:
            switch (tableName) {
                case TABLES.PEOPLE_MANAGE_COMP_OFF:
                    column.allowFilter = false;
                    column.uiVisible = false;
                    column.hidden =  true;
                    break;
            }
            break;
        case COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.COMP_OFF_FOR:
        case COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.DESCRIPTION:
            switch (tableName) {
                case TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS:
                    column.allowFilter = false;
                    break;
            }
        case COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.EXPIRY_AT:
        case COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.EXPIRY_MODE:
        case COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.WORKING_HOLIDAY:
            switch (tableName) {
                case TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS:
                    column.allowFilter = false;
                    break;
            }
        case COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.STATUS:
            switch (tableName) {
                case TABLES.PEOPLE_MANAGE_COMP_OFF:
                    column.allowFilter = false;
                    break;
            }
            break;
        case COLUMN_CODE.PROCESS_PAYROLL.EMPLOYEE_ID:
            switch (tableName) {
                case TABLES.PAYROLL_PROCESS:
                case TABLES.PAYROLL_SUMMARY:
                    column.uiVisible = false;
                    column.hidden = true;
                    break;
            
                default:
                    break;
            }
            break;
        case COLUMN_CODE.CUSTOM_FIELD_LIST.MAX_LENGTH:
        case COLUMN_CODE.CUSTOM_FIELD_LIST.DISPLAY_IN:
            column.editable = false;
            column.allowColumnSort = false;
            break;
        case COLUMN_CODE.CUSTOM_FIELD_LIST.TYPE:
            column.editable = false;
            break;
        case COLUMN_CODE.PEOPLE_PERFORMANCE_GOAL.PROGRESS:
            column.hidden =  true;
            column.editable = false;
            break;
        case COLUMN_CODE.PEOPLE_PERFORMANCE_GOAL.APPLICABLE_TO:
            column.hidden = !PermissionUtils.hasAccess(MODULE.PERFORMANCE_GOAL, ACTION.VIEW) ? true : false;
            break;
    }
    if(tableName == TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST ) {
        switch(column.columnCode) {
            case COLUMN_CODE.PEOPLE_APPLY_COMP_OFF_REQUEST.STATUS:
                column.allowFilter = true;
                break;
            default :
                column.allowFilter = false;
        }
    }
  });
  return columnData;
}
export function parseJEColumnConfig(columnData,isSync) {
    columnData.forEach((column) => {
      column["key"] = column.columnCode;
      switch(column.columnCode) {
          case "payPeriod":
          case "totalCost":
          case "employeeCount":
            column.width = 200;
            break;
          case "jeRevertDate":
              column.editable = true;
              column.hidden = isSync;
              column.uiVisible = !isSync;
              column.width = 300;
              break;
          case "jePostedOn":
              column.editable = isSync;
              column.width = 200;
              break;
      }
    });
    return columnData;
  }
export function changeColumnName(columnData,stage='',tableName='',obj={}) {
    columnData.forEach(column => {
        switch(column.columnCode){
            case 'submitOn':
                switch(stage) {
                    case INVESTMENT_STAGE.ACTUAL:
                        column['name'] = 'Submitted Date';
                        break;
                    case INVESTMENT_STAGE.DECLARATION:
                        column['name'] = 'Declaration Date';
                        break;
                    case INVESTMENT_STAGE.APPROVED:
                        column['name'] = 'Approved Date';
                        break;
                    default:
                        column['name'] = column['name']
                }
            break;
            case 'name':
                switch(tableName) {
                    case TABLES.PEOPLE_COMPONENT:
                        if(obj && !obj.isFromEmployeeSetup) {
                            column['name'] = 'Employee Name';
                        } else {
                            column['name'] = 'Employee';
                        }
                        break;
                }
        }
    });
    return columnData;
}
function earlyOrLate(element, isEntry) {
    if (element == '' || element == 0) {
        return element = 0
    } else if (element > 0) {
        return element = isEntry ? getEarly(element) : getLate(element);
    } else if (element < 0) {
        return element = isEntry ? getLate(element) : getEarly(element)
    } else {
        return element = 0
    }
}
function getLate(element) {
    return `<div class="row flex-wrap">
        <span class="pr-s">${getTimeFromMins(Math.abs(element), "HH:mm")}</span><div class="row fs-m  pt-xs pb-xs pl-s pr-s border-radius-s data-grid-badge-color-4 text-red" style="width: auto;">
            <div class=" fs-r text-align-left  display-block " style="overflow-wrap: break-word; ">Late</div>
        </div>
        </div>`
}
function getEarly(element) {
    return `<div class="row flex-wrap">
        <span class="pr-s">${getTimeFromMins(Math.abs(element), "HH:mm")}</span><div class="row fs-m  pt-xs pb-xs pl-s pr-s border-radius-s data-grid-badge-color-6 text-green" style="width: auto;">
            <div class=" fs-r text-align-left  display-block " style="overflow-wrap: break-word;">Early</div>
        </div>
        </div>`
}

function getFieldWithLabelAndAmount(label, amount) {
    return `<div class="row flex-wrap ml-l">
        <div class="row fs-m  pt-xs pb-xs pl-s pr-s mr-l border-radius-s data-grid-badge-color-6 text-green" style="width: auto;">
            <div class=" fs-r text-align-left  display-block " style="overflow-wrap: break-word;">${label}</div>
        </div>
        <span class="pr-s">${amount}</span>
        </div>`
}
function getTimeFromMins(mins, format) {
    // do not include the first validation check if you want, for example,
    // getTimeFromMins(1530) to equal getTimeFromMins(90) (i.e. mins rollover)
    //create duration object from moment.duration
    var duration = moment.duration(mins, 'minutes');

    //calculate hours
    var hh = (duration.years() * (365 * 24)) + (duration.months() * (30 * 24)) + (duration.days() * 24) + (duration.hours());

    //get minutes
    var mm = duration.minutes();

    //return total time in hh:mm format
    return (hh < 10 ? '0' + hh : hh) + ':' + (mm < 10 ? '0' + mm : mm);
}
function getUserNameColumn(obj,isCardView) {
    const cardView = isCardView ? isCardView :'designation';
    const isAdmin = TenantService.get(TENANT.IS_ADMIN)
    const userNameClasses = ` ${isCardView ? ((isAdmin) ? "ellipsis max-width-200": "ellipsis max-width-245"):"" }`
    var url = getUserProfilePic({
        name: obj.employeeName,
        backgroundColor: '#001F42',
        textColor: '#FFF',
        font: 'bold 24px sans-serif',
        height: 72,
        width: 72,
    });
    return `<div class="row">
    <div class="d-flex"><h4 class="m-0  " style="margin-bottom:0px">${obj.employeeName}</h4><p class="m-0 text-gray fw-m" style='margin-top:0px'>${(!Utility.isEmpty(obj[cardView])? (' ('+obj[cardView]+') '):'')}</p></div></div>`
}

function getUserNameColumnForEmployeeList(user, isSetup, isCashfreeEnabled) {
    var url = getUserProfilePic({
      name: `${user.firstName} ${user.lastName}`,
      backgroundColor: "#001F42",
      textColor: "#FFF",
      font: "bold 24px sans-serif",
      height: 72,
      width: 72,
    });
    return `<div class="row">
    <div class="d-flex"><h4 class="m-0 " style="margin-bottom:0px">${getEmployeeListColumnDetails(user, isSetup, isCashfreeEnabled)}</h4></div></div>`;
}

function getUserNameInProcessPayroll(payroll) {
    var url = getUserProfilePic({
        name: payroll.firstName + CONSTANTS.EMPTY_STRING_WITH_SPACE + payroll.lastName,
        backgroundColor: '#001F42',
        textColor: '#FFF',
        font: 'bold 24px sans-serif',
        height: 72,
        width: 72,
    });
    return `<div class="row mt-s" style="align-items:start">
    <div class="column"><div style="margin-bottom:0px">${getEmployeeColumDetails(
      payroll
    )}</div></div></div>`;
}

function getOTForProcessPayroll(payroll, isEditEnable) {

    let otField = CONSTANTS.EMPTY_STRING
    otField = `<div style="display: grid; min-width: 300px;">
        <div class="row mt-r">
            <div class="row" style="">
            <div  class = "column mr-l" style="width: 20%" >
            <div class="fs-r fw-m pb-4 ot-align" style="" > OT</div>
            </div>
            <div class = "column mr-l" style="width: 20%">
                <div class="fs-r fw-m pb-4 ot-align" style="" > Hrs</div>
            </div>
            <div class="column mr-l" style="width: 28%">
                <div class="fs-r fw-m pb-4 ot-align" style="" > Rate</div>
            </div>
            <div class="column" style="width: 30%">
                <div class="fs-r fw-m pb-4 ot-align" style="" > Amount</div>
            </div>
            </div>

        </div>`;
    if (payroll && payroll.overtime && payroll.overtime.length > 0) {
        payroll.overtime.forEach((item, index)=>{
            otField += getInputFieldForOT(item.rate, item.value, item.amount, index, payroll._id, isEditEnable, payroll)
        })
    } else {
        otField += getInputFieldForOT(1.5, 0, 0.0, 0, payroll._id, isEditEnable, payroll)
        otField += getInputFieldForOT(2.0, 0, 0.0, 1, payroll._id, isEditEnable, payroll)
    }

    return otField += `</div>`

}

const getEmployeeColumDetails = (payroll) => {
    let employeeColumn = CONSTANTS.EMPTY_STRING
    employeeColumn += `<div class="row" style="font-weight:bold">${payroll.firstName}`;
    employeeColumn += payroll.lastName ? ` ${payroll.lastName}`:``;
    if (payroll && payroll.unfilledFields && payroll.unfilledFields.length > 0) {
        let tooltipText = `<div class=''><div class='fw-m'>Incomplete Employee Information</div><div class='d-flex fs-s' style='justify-content:flex-start; padding-top:3px;'>Please fill the following:</div>${payroll['unfilledFields'].map((f, i) =>`<div class='d-flex fs-s' style='justify-content:flex-start; padding-top:3px'>${i + 1}. ${getFieldName(f)}</div>`).join('')}</div>`;
        employeeColumn += `<span class="ml-s info_error_icon" data-tip="${tooltipText}"><img class="ic-s" src= ${ic_info_error} /></span>`;
    }
    employeeColumn += `</div><div class="text-gray fs-r"><span style="font-weight:bold">${FormatCurrencyService.format(payroll.netPayrun)}</span>${CONSTANTS.PER_PAYRUN}</div>`;
    if (payroll.compensationPeriod === CONSTANTS.HOURLY) {
      employeeColumn += `<div class="text-gray fs-r">${CONSTANTS.REGULAR_HOURS}: <span style="font-weight:bold">${payroll.hoursWorked} ${CONSTANTS.HOURS}</span></div>`;
    } else {
      employeeColumn += `<div class="text-gray fs-r">${CONSTANTS.REGULAR_DAYS}: <span style="font-weight:bold">${payroll.daysWorked}</span></div>`;
    }
    if (!Utility.isEmpty(payroll.paymentMethod)) {
      employeeColumn += `<div class="text-gray fs-r">${
        CONSTANTS.PAYMENT
      }:<span class="cursor-hand fw-m" id=payment_method_${payroll._id}>${isUSCompliance() ? PAYMENT_MAP_US[payroll.paymentMethod]:PAYMENT_MAP[payroll.paymentMethod]}</span></div>`;
    }
    employeeColumn += `<div class="text-gray fs-r">${CONSTANTS.EMPLOYEE_ID}: <span style="font-weight:bold">${payroll.empId}</span></div>`
    return employeeColumn
}

const getEmployeeListColumnDetails = (user, isPayrollSetup, isCashfreeEnabled) => {
    let employeeColumn = CONSTANTS.EMPTY_STRING;
    employeeColumn += `<div class="row" style="font-weight:bold">${user.firstName}`;
    employeeColumn += user.lastName ? ` ${user.lastName}` : ``;
    employeeColumn += `<p class="m-0 text-gray fw-m" style='margin-top:0px'>${(user.designation !=''? (' ('+user.designation+') '):'')}</p>`
    if (!isPayrollSetup && user.inCompleteFields && user.inCompleteFields.length > 0) {
        let tooltipText = `<div><div class='fw-m'>Incomplete Employee Profile</div><div class='d-flex fs-s' style='justify-content:flex-start; padding-top:3px;'>Fields missing:</div>${user['inCompleteFields'].map((f, i) =>`<div class='d-flex fs-s' style='justify-content:flex-start; padding-top:3px'>${i + 1}. ${getIncompleteFieldName(f)}</div>`).join('')}</div>`;
        employeeColumn += `<span class="ml-s info_error_icon" data-tip="${tooltipText}"><img class="ic-s" src= ${ic_info_error} /></span>`;
    } else if (!isPayrollSetup && isCashfreeEnabled && user.beneficiaryStatus === CONSTANTS.FAILED_TO_ADD && !Utility.isEmpty(user.beneficiaryReason)) {
        let tooltipText = user.beneficiaryReason;
        employeeColumn += `<span class="ml-s info_error_icon" data-tip="${tooltipText}"><img class="ic-s" src= ${ic_info_error} /></span>`;
    } else if (!isPayrollSetup && isCashfreeEnabled && isPaymentMethodNotAvailable(user)) {
        let getFieldArray = getIncompletePaymentDetailsFieldArry(user)
        let tooltipText = `<div><div class='fw-m'>Incomplete Payment Details</div><div class='d-flex fs-s' style='justify-content:flex-start; padding-top:3px;'>Fields missing:</div>${getFieldArray.map((f, i) =>`<div class='d-flex fs-s' style='justify-content:flex-start; padding-top:3px'>${i + 1}. ${f}</div>`).join('')}</div>`;
        employeeColumn += `<span class="ml-s info_error_icon" data-tip="${tooltipText}"><img class="ic-s" src= ${ic_info_error} /></span>`;
    } else if(!isPayrollSetup && isCashfreeEnabled && isNumberNotAvailable(user)) {
        let getFieldArray = ["Contact"];
        let tooltipText = `<div><div class='fw-m'>Incomplete Employee Profile</div><div class='d-flex fs-s' style='justify-content:flex-start; padding-top:3px;'>Fields missing:</div>${getFieldArray.map((f, i) =>`<div class='d-flex fs-s' style='justify-content:flex-start; padding-top:3px'>${i + 1}. ${f}</div>`).join('')}</div>`;
        employeeColumn += `<span class="ml-s info_error_icon" data-tip="${tooltipText}"><img class="ic-s" src= ${ic_info_error} /></span>`;
    }

    return employeeColumn
}

const getEmployerContribution = (payroll) => {
    let employerContribtuion = CONSTANTS.EMPTY_STRING
    if (payroll && payroll.compliance && payroll.compliance.employerContribution) {
        Object.keys(payroll.compliance.employerContribution).forEach(item => {
            if(getTenantCountryCode() === COUNTRY.SG && !ITEMS_TO_SKIP_CONTRIBUTION.includes(item) && !Utility.isEmpty(payroll.compliance.employerContribution[item])) {
                employerContribtuion += `<div class="row"> <div style="width:150px; flex-grow:1; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;text-align: right;">${getContributionName(item)}</div>
                <div style="font-weight:bold; width:105px; text-align:right">${FormatCurrencyService.format(payroll.compliance.employerContribution[item])}</div></div>`;
            } else if(getTenantCountryCode() != COUNTRY.SG) {
                employerContribtuion += `<div class="row"> <div style="width:150px; flex-grow:1; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;text-align: right;">${getContributionName(item)}</div>
                <div style="font-weight:bold; width:105px; text-align:right">${FormatCurrencyService.format(payroll.compliance.employerContribution[item])}</div></div>`;
            }
        })
    }

    if (payroll && payroll.benefits && payroll.benefits.length > 0) {
        Object.keys(payroll.benefits).forEach(item => {

            employerContribtuion += `<div class="row"> <div style="width:150px; flex-grow:1; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;text-align: right;">${payroll.benefits[item].name}</div>
                <div style="font-weight:bold; width:105px; text-align:right">${FormatCurrencyService.format(payroll.benefits[item].employerContribution)}</div></div>`;
        })
    }
    return employerContribtuion
}

const getDeduction = (payroll) => {
    let deduction = CONSTANTS.EMPTY_STRING
    if (payroll && payroll.compliance && payroll.compliance.employeeContribution) {
        Object.keys(payroll.compliance.employeeContribution).forEach(item => {
            if(getTenantCountryCode() === COUNTRY.SG && !ITEMS_TO_SKIP_CONTRIBUTION.includes(item) && !Utility.isEmpty(payroll.compliance.employeeContribution[item])) {
                deduction += `<div class="row"> <div style="width:150px; flex-grow:1; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;text-align: right;">${getContributionName(item)}</div>
                <div style="font-weight:bold; width:105px; text-align:right">${FormatCurrencyService.format(payroll.compliance.employeeContribution[item])}</div></div>`;
            } else if(getTenantCountryCode() != COUNTRY.SG) {
                deduction += `<div class="row"> <div style="width:150px; flex-grow:1; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;text-align: right;">${getContributionName(item)}</div>
                <div style="font-weight:bold; width:105px; text-align:right">${FormatCurrencyService.format(payroll.compliance.employeeContribution[item])}</div></div>`;
            }
        })
    }
    if (payroll && payroll.components) {
        payroll.components.forEach((components, index) => {
            if (components.type == CONSTANTS.DEDUCTION || components.type === COMPONENT_TYPE.DEDUCTION) {
                deduction += `<div class="row"> <div style="width:150px; flex-grow:1; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;text-align: right;">${components.name}</div>
                <div style="font-weight:bold; width:105px; text-align:right">${FormatCurrencyService.format(components.amount)}</div></div>`;
            }
        })
    }


    if (payroll && payroll.benefits && payroll.benefits.length > 0) {
        Object.keys(payroll.benefits).forEach(item => {

            deduction += `<div class="row"> <div style="width:150px; flex-grow:1; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;text-align: right;">${payroll.benefits[item].name}</div>
                <div style="font-weight:bold; width:105px; text-align:right">${FormatCurrencyService.format(payroll.benefits[item].employeeContribution)}</div></div>`;
        })
    }
    return deduction
}

const getAdditionalEarning = (payroll) => {
    let additionEarning = CONSTANTS.EMPTY_STRING
    let fixedAllowanceError = "Please get the attendance filled for the employee<br>or adjust other fixed component values";
    if (payroll && payroll.components) {
        payroll.components.forEach((components, index) => {
            if (components.type == CONSTANTS.EARNING) {
                if (components.name === CONSTANTS.FIXED_ALLOWANCE && components.amount < 0) {
                    additionEarning += `<div class="row"><img class="ic-s mr-s"src= ${ic_info_error} data-tip= "${fixedAllowanceError}" /><div style="width:150px; flex-grow:1; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;text-align: right;">${components.name}</div>
                <div style="font-weight:bold; width:105px; text-align:right">${FormatCurrencyService.format(components.amount)}</div></div>`;
                } else {
                    additionEarning += `<div class="row"><div style="width:150px; flex-grow:1; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;text-align: right;">${components.name}</div>
                <div style="font-weight:bold; width:105px; text-align:right">${FormatCurrencyService.format(components.amount)}</div></div>`;
                }
            }
        })
    }
    return additionEarning
}

const getInputFieldForOT = (rate, value, amount, index, id, isEditEnabled, payrollData) => {
    const rateId=  `${index}_rate_${id}`
    const valueId= `${index}_value_${id}`
    let isDisabled = !isEditEnabled ? "disabled" : "";
    const hourlyPay = payrollData && (payrollData.otPayRate ? payrollData.otPayRate : ((payrollData.hourlyPay ? payrollData.hourlyPay : 0)))  ;
    PayrollManager.otIds.push(rateId)
    PayrollManager.otIds.push(valueId)

    return `<div class="row m-v-r">
            <div class="row" style="">
            <div  class = "column" style="width: 20%" >
                <input id="${rateId}" type="number" class="incrementor-input fs-r parent-width overtime01" ${isDisabled} value='${rate}' style="padding-left:5px" />
            </div>
            <div class="column text-gray" style="margin-left:15px">
                <span>x</span>
            </div>
            <div class = "column" style="width: 20%">
                <input id="${valueId}" type="text" class="incrementor-input fs-r parent-width overtime02 " ${isDisabled}  value='${value}' style="padding-left:5px"/>
            </div>
            <div class="column text-gray" style="margin-left:15px">
                <span class="" style="padding-left:4px;padding-right:4px">x</span>
            </div>
            <div class="column  align-items-start" style="width: 28%">
                    <span class=" text-gray d-flex align-items-center" style="height:30px;">${FormatCurrencyService.format(
                        hourlyPay
                    )}</span>
            </div>
            <div class="column text-gray" style="padding-right:10px">
                <span class="">=</span>
            </div>
            <div class="column  align-items-start" style="width: 32%">
                    <span class=" text-gray d-flex align-items-center" style="height:30px;">${
                      amount
                        ? FormatCurrencyService.format(amount)
                        : FormatCurrencyService.format(0)
                    }</span>
            </div>
            </div>

        </div>`;
}

const getFieldName = (field) => {
        let fieldName = '';
        switch (field) {
            case IMP_FIELDS.EMAIL_ID:
                fieldName = "Email";
                break;
            case IMP_FIELDS.DATE_OF_BIRTH:
                fieldName = "Date of Birth";
                break;
            case IMP_FIELDS.DATE_OF_JOINING:
                fieldName = "Date of Joining";
                break;
            case IMP_FIELDS.COMPLIANCE:
                fieldName = "Compliance";
                break;
            case IMP_FIELDS.PAYMENT_METHOD:
                fieldName = i18next.t("PAYMENT_METHOD");
                break;
        }
        return fieldName;
    }

    export function columnConfigForPayrollSummary(employeePayrollList, isEditEnable, isCashfreeEnabled, filterValue, isContractor) {
    let rowData = [];
    let incompleteProfiles = [];
    let cashfreeWarnings = [];
    PayrollManager.otIds = []
    if (employeePayrollList && employeePayrollList.payrolls && employeePayrollList.payrolls.length > 0) {
        let payrolls = employeePayrollList.payrolls;
        switch(filterValue) {
            case 1:
                payrolls = payrolls.filter((x) => PAYMENT_MAP[x.paymentMethod] === CONSTANTS.DIRECT_DEPOSIT);
                break;
            case 2:
                payrolls = payrolls.filter((x) => PAYMENT_MAP[x.paymentMethod] === CONSTANTS.CASH);
                break;
            case 3:
                payrolls = payrolls.filter((x) => PAYMENT_MAP[x.paymentMethod] === CONSTANTS.CHEQUE || PAYMENT_MAP[x.paymentMethod] === CONSTANTS.CHECK);
                break;
            case 4:
                payrolls = payrolls.filter((x) => PAYMENT_MAP[x.paymentMethod] === CONSTANTS.UPI);
                break;
        }
        if(isContractor != "true") {
            payrolls.forEach((payroll, index) => {
            const row = {
                [COLUMN_CODE.PAYROLL_SUMMARY.EMPLOYEE]: getUserNameInProcessPayroll(payroll),
                [COLUMN_CODE.PAYROLL_SUMMARY.OVERTIME]: getOTForProcessPayroll(payroll, isEditEnable),
                [COLUMN_CODE.PAYROLL_SUMMARY.LOP]: getLOPForProcessPayroll(payroll, isEditEnable),
                [COLUMN_CODE.PAYROLL_SUMMARY.EMPLOYER_CONTRIBUTION]: getEmployerContribution(payroll),
                [COLUMN_CODE.PAYROLL_SUMMARY.ADDITIONAL_EARNING]: getAdditionalEarning(payroll),
                [COLUMN_CODE.PAYROLL_SUMMARY.DEDUCTION]: getDeduction(payroll),
                [COLUMN_CODE.PAYROLL_SUMMARY.NET_PAY]: `<div class="row" style="text-align:right"><span >${payroll.netPay}</span></div>`,
                [COLUMN_CODE.PAYROLL.ID]: payroll._id ? payroll._id : index,
                [COLUMN_CODE.PAYROLL_SUMMARY.PAYRUN_ID]: payroll.payrunId,
                [COLUMN_CODE.PAYROLL_SUMMARY.EMPLOYEE_NAME]: payroll.firstName + CONSTANTS.EMPTY_STRING_WITH_SPACE + payroll.lastName,
                [COLUMN_CODE.PAYROLL_SUMMARY.PAYMENT_STATUS]: isCashfreeEnabled ? getPaymentStatus(payroll, cashfreeWarnings) : (payroll.processed ? CASHFREE_PAYMENT_STATUS.PAID : CASHFREE_PAYMENT_STATUS.PAYMENT_PENDING),
                "employeeId": payroll.employeeId,
                [COLUMN_CODE.PROCESS_PAYROLL.EMPLOYEE_ID]: payroll.empId
            };
            if (payroll && payroll.unfilledFields && payroll.unfilledFields.length > 0) {
                incompleteProfiles.push(row);
            }
            rowData.push(row);
            });
        } else if(isContractor === "true") {
        employeePayrollList.payrolls.forEach((payroll, index) => {
            const row = {
                [COLUMN_CODE.PAYROLL_SUMMARY.EMPLOYEE]: getUserNameInContractorProcessPayroll(payroll),
                [COLUMN_CODE.PAYROLL_SUMMARY.OVERTIME]: payroll.compensationPeriod === CONSTANTS.HOURLY ? getRHForProcessPayroll(payroll, isEditEnable):"",
                [COLUMN_CODE.PAYROLL_SUMMARY.ADDITIONAL_EARNING]: getAdditionalEarning(payroll),
                [COLUMN_CODE.PAYROLL_SUMMARY.NET_PAY]: `<div class="row" style="text-align:right"><span >${FormatCurrencyService.format(payroll.netPay)}</span></div>`,
                [COLUMN_CODE.PAYROLL_SUMMARY.ID]: payroll._id ? payroll._id : index,
                [COLUMN_CODE.PAYROLL_SUMMARY.PAYRUN_ID]: employeePayrollList._id ? employeePayrollList._id : index,
                [COLUMN_CODE.PAYROLL_SUMMARY.EMPLOYEE_NAME]: payroll.firstName + CONSTANTS.EMPTY_STRING_WITH_SPACE + payroll.lastName,
                [COLUMN_CODE.PAYROLL_SUMMARY.DEDUCTION]: getDeduction(payroll),
                [COLUMN_CODE.PAYROLL_SUMMARY.PAYMENT_STATUS]: isCashfreeEnabled ? getPaymentStatus(payroll, cashfreeWarnings) : (payroll.processed ? CASHFREE_PAYMENT_STATUS.PAID : CASHFREE_PAYMENT_STATUS.PAYMENT_PENDING)
            };
            rowData.push(row);
        });
    }
    }

    return { rowData, incompleteProfiles, cashfreeWarnings };
}

function getPaymentStatus(payrollData, cashfreeWarnings) {
    let status = payrollData && payrollData.processed ? CASHFREE_PAYMENT_STATUS.PAYMENT_PENDING : CASHFREE_PAYMENT_STATUS.PAYMENT_PENDING;
    let paymentMethod = payrollData && payrollData.paymentMethod ? payrollData.paymentMethod : "";
    if (PAYMENT_MAP[paymentMethod] === CONSTANTS.DIRECT_DEPOSIT || PAYMENT_MAP[paymentMethod] === CONSTANTS.UPI) {
        if (payrollData.processed && payrollData.isPaymentDone) {
        status = CASHFREE_PAYMENT_STATUS.PAID;
        } else if (payrollData.processed && !payrollData.isPaymentDone && !Utility.isEmpty(payrollData.paymentFailureReason)) {
        let tooltipText = payrollData.paymentFailureReason;
        status = `<div class="d-flex">${CASHFREE_PAYMENT_STATUS.PAYMENT_FAILED}`;
        status += `<span class="ml-s info_error_icon" data-tip="${tooltipText}"><img class="ic-s" src= ${ic_info_error} /></span></div>`;
        let value = CASHFREE_MESSAGE_MAP[payrollData.paymentFailureReason];
        if (value && value.status) {
          let isPresent = cashfreeWarnings.find((x) => x === value.message);
          if (!isPresent) {
              cashfreeWarnings.push(value.message);
          }
        }
        } else if(payrollData.processed && !payrollData.isPaymentDone && Utility.isEmpty(payrollData.paymentFailureReason)) {
        status = CASHFREE_PAYMENT_STATUS.PAYMENT_PENDING;
        }
    } else {
        if (payrollData.processed) {
            status = CASHFREE_PAYMENT_STATUS.PAID;
        } else {
            status = CASHFREE_PAYMENT_STATUS.NOT_PAID;
        }
    }
    return status;
}

function getPaymentStatusForPayrunList(payrollData) {
    let status = payrollData && payrollData.processed ? CASHFREE_PAYMENT_STATUS.PAID : CASHFREE_PAYMENT_STATUS.PAYMENT_PENDING;
    if (payrollData.processed && payrollData.isPaymentDone && payrollData.paymentFailureCount === 0) {
        status = CASHFREE_PAYMENT_STATUS.PAID;
    } else if (
      payrollData.processed &&
      payrollData.paymentCount != 0 &&
      payrollData.paymentFailureCount != 0 &&
      payrollData.paymentFailureCount === payrollData.paymentCount
    ) {
      if (!Utility.isEmpty(payrollData.paymentFailureReason)) {
        let tooltipText = payrollData.paymentFailureReason;
        status = `<div class="d-flex">${CASHFREE_PAYMENT_STATUS.PAYMENT_FAILED}`;
        status += `<span class="ml-s info_error_icon" data-tip="${tooltipText}"><img class="ic-s" src= ${ic_info_error} /></span></div>`;
      } else {
        let tooltipText = "Payment Failed. Please check summary to know more.";
        status = `<div class="d-flex">${CASHFREE_PAYMENT_STATUS.PAYMENT_FAILED}`;
        status += `<span class="ml-s info_error_icon" data-tip="${tooltipText}"><img class="ic-s" src= ${ic_info_error} /></span></div>`;
      }
    } else if (
      payrollData.processed &&
      payrollData.paymentCount != 0 &&
      payrollData.paymentFailureCount != 0 &&
      payrollData.paymentFailureCount != payrollData.paymentCount
    ) {
      let tooltipText = "Payment Partially Paid. Please check summary to know more.";
      status = `<div class="d-flex">${CASHFREE_PAYMENT_STATUS.PARTIALLY_PAID}`;
      status += `<span class="ml-s info_error_icon" data-tip="${tooltipText}"><img class="ic-s" src= ${ic_info_error} /></span></div>`;
    }
    return status;
}

function getContextMenuFroCompOffRequest (compOffRequest, functionConfig) {
    let action = [];

    if(compOffRequest.status == "PENDING" ) {
        if(PermissionUtils.hasAccess(MODULE.MANAGE_COMP_OFF_REQUEST,[ACTION.APPROVE])) {
            action.push({
                title: "Approve",
                icon: ic_check_mark,
                onClick: (data) => {
                  functionConfig.onApprove(data);
                },
            })
        }
        if(PermissionUtils.hasAccess(MODULE.MANAGE_COMP_OFF_REQUEST,[ACTION.REJECT])) {
            action.push({
                title: "Reject",
                icon: ic_close,
                onClick: (data) => {
                  functionConfig.onReject(data);
                },
            });
        }
        
    }


    if(moment(compOffRequest.expiryDate, CONSTANTS.YYYYMMDD).diff(moment(),'days') >= 0 &&
    PermissionUtils.hasAccess(MODULE.MANAGE_COMP_OFF_REQUEST,[ACTION.DELETE])) {
        let deleteRow = {
            title: "Delete",
            icon: DKIcons.ic_delete,
            onClick: (data) => {
              functionConfig.onDelete(data);
            },
        };
        action.push(deleteRow)

    }

    return action
}

function getContextMenuForExpenseGroupGrid(expense, functionConfig) {
    let action = [];
    if (expense.name !== "default" && PermissionUtils.hasAccess(MODULE.EXPENSE_ADMIN_SETTING,[ACTION.DELETE])) {
        action.push({
            title: "Delete",
            icon: DKIcons.ic_delete,
            onClick: (data) => {
                functionConfig.deleteGroup(data);
            },
        });
    }
    return action
}

function getContextMenuForPayrollGrid (payroll, functionConfig, recentProcessedId, module) {
    let action = [];
    if (payroll.processed) {
        action.push({
          title: "View",
          icon: ic_visibility,
          onClick: (data) => {
            functionConfig.viewPayroll(data);
          },
        });
        if (
            (!Utility.isEmpty(recentProcessedId)) && 
            ( payroll?._id === recentProcessedId) && 
            (!isMYCompliance()) && 
            !payroll.isForContractors && 
            PermissionUtils.hasAccess(module,ACTION.SUBMIT)
        ) {
            action.push({
              title: "Revert",
              icon: ic_replay,
              onClick: (data) => {
                functionConfig.revertPayrun(data);
              },
            });
        }
        if((isMYCompliance() || isSGCompliance()) && !payroll.isForContractors && PermissionUtils.hasAccess(module,ACTION.SUBMIT) && PermissionUtils.hasAccess(MODULE.GIRO,[ACTION.CREATE,ACTION.EDIT])) {
            action.push({
                title: "Make Payment",
                icon: ic_credit_card,
                onClick: (data) => {
                  functionConfig.makePayment(data);
                },
              });
        } else if(isUSCompliance() && !payroll.isForContractors) {
            action.push({
                title: "Download MasterTax PTS Import file",
                icon: ic_download,
                onClick: (data) => {
                  functionConfig.downloadPTSFile(data);
                },
              });
        }
    } else {
        let edit = {
          title: "Edit",
          icon: DKIcons.ic_edit,
          onClick: (data) => {
            functionConfig.editPayroll(data);
          },
        };
        if(PermissionUtils.hasAccess(module,ACTION.EDIT)) {
            action.push(edit)
        }
        
        let deleteRow = {
          title: "Delete",
          icon: DKIcons.ic_delete,
          onClick: (data) => {
            functionConfig.deletePayroll(data);
          },
        };
        if(PermissionUtils.hasAccess(module,[ACTION.DELETE])) {
            action.push(deleteRow)
        }
        
        let processPayroll = {
          title: "Process",
          icon: ic_autorenew,
          onClick: (data) => {
            functionConfig.processPayroll(data);
          },
        };
        if(PermissionUtils.hasAccess(module,[ACTION.SUBMIT])) {
            action.push(processPayroll);
        }
        
    }
    return action;
}

function getContextMenuForEmployeeGrid(employee, functionConfig) {
    let action = [];
    let viewEmployee = {
        title: "View",
        icon: ic_visibility,
        onClick: (data) => {
            functionConfig.viewEmployee(data);
        },
    };
    action.push(viewEmployee);
    let deleteEmployee = {
        title: "Delete",
        icon: DKIcons.ic_delete,
        onClick: (data) => {
            functionConfig.deleteEmployee(data);
        },
    };
    if(PermissionUtils.hasAccess(MODULE.EMPLOYEE, ACTION.DELETE)) {
        action.push(deleteEmployee)
    }
    if (employee.status !== CONSTANTS.DRAFT &&employee.terminationStage !== "terminated" && PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT, ACTION.CREATE])) {
        let viewPayroll = {
            title: "Terminate",
            icon: DKIcons.ic_close,
            onClick: (data) => {
                functionConfig.terminateEmployee(data);
            },
        };
        action.push(viewPayroll);
    }
    if(isRehireEnable() &&  employee.terminationStage === 'terminated' && PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT, ACTION.CREATE])) {
        let viewPayroll = {
            title: "Rehire",
            icon: ic_replay,
            onClick: (data) => {
                functionConfig.rehireEmployee(data);
            },
        };
        action.push(viewPayroll);
    }
    return action;
}

function getContextMenuForImport(log,functionConfig) {

    let action = []
    if(log.updatedFilePath) {
        action.push({
            title: "Imported File",
            icon: ic_file_green,
            onClick: (data) => {
              functionConfig.downloadUpdated(data);

            }
        })

    }
    if(log.rejectedFilePath) {
        action.push({
            title: "Rejected File",
            icon: ic_file_red,
            onClick: (data) => {
              functionConfig.downloadRejected(data);

            }
        })
    }

    return action
}

function isPaymentMethodNotAvailable (data) {
    let isInValid = false;
    let paymentObject = data && data.paymentDetails ? data.paymentDetails : {};
    try{
        if (paymentObject && !Utility.isEmpty(paymentObject.paymentMethod)) {
            if(PAYMENT_MAP[paymentObject.paymentMethod] === CONSTANTS.DIRECT_DEPOSIT && (Utility.isEmpty(paymentObject.ifsc) || Utility.isEmpty(paymentObject.accountNumber))) {
                isInValid = true
            } else if (
              PAYMENT_MAP[paymentObject.paymentMethod] === CONSTANTS.UPI &&
              Utility.isEmpty(paymentObject.upi)
            ) {
                isInValid = true;
            }
        } else {
            isInValid = true;
        }
    } catch(err) {
        return (isInValid = false);
    }
    return isInValid;

}

function getIncompletePaymentDetailsFieldArry (data) {
let fieldArray = [];
    let paymentObject = data && data.paymentDetails ? data.paymentDetails : {};
    try{
        if (paymentObject && !Utility.isEmpty(paymentObject.paymentMethod)) {
            if(PAYMENT_MAP[paymentObject.paymentMethod] === CONSTANTS.DIRECT_DEPOSIT && (Utility.isEmpty(paymentObject.ifsc) || Utility.isEmpty(paymentObject.accountNumber))) {
                if (Utility.isEmpty(paymentObject.ifsc)) {
                  fieldArray.push("IFSC Code");
                }
                if (Utility.isEmpty(paymentObject.accountNumber)) {
                  fieldArray.push("Account Number");
                }
            } else if (
              PAYMENT_MAP[paymentObject.paymentMethod] === CONSTANTS.UPI &&
              Utility.isEmpty(paymentObject.upi)
            ) {
                fieldArray.push("UPI Id");
            }
        } else {
            fieldArray.push("Payment Method");
        }
    } catch(err) {
        return (fieldArray = []);
    }
    return fieldArray;
}

function isNumberNotAvailable(data) {
  let isInValid = false;
  let paymentObject = data && data.paymentDetails ? data.paymentDetails : {};
  try {
    if (paymentObject && !Utility.isEmpty(paymentObject.paymentMethod)) {
      if (
        (PAYMENT_MAP[paymentObject.paymentMethod] === CONSTANTS.DIRECT_DEPOSIT || PAYMENT_MAP[paymentObject.paymentMethod] === CONSTANTS.UPI) &&
        Utility.isEmpty(data.contact)
      ) {
        isInValid = true;
      }
    } else if (Utility.isEmpty(data.contact)) {
      isInValid = true;
    }
  } catch (err) {
    return (isInValid = false);
  }
  return isInValid;
}

export function getClockInLocationCoordinates(details) {
  const latitude = details.clockInLatitude;
  const longitude = details.clockInLongitude;
  if (details && !Utility.isEmpty(longitude) && !Utility.isEmpty(latitude)) {
    const status = `<div class="row flex-wrap"><span class="pr-s">${details.clockIn ? moment(details.clockIn).format("hh:mm A") : "-"}</span><div class="row fs-m  pt-xs pb-xs pl-s pr-s border-radius-s data-grid-badge-color-6 text-green" style="width: auto;"><div class=" fs-r text-align-left  display-block " style="overflow-wrap: break-word;"}"><a class="cursor-hand" onclick="window.openSelectedLocation(${latitude},${longitude})">Coordinates</a></div></div></div>`;
    return status;
  }
  return `${details.clockIn ? moment(details.clockIn).format("hh:mm A") : "-"}`;
}

export function getPunchAtLocationCoordinates(details) {
  const latitude = details.latitude;
  const longitude = details.longitude;
  if (details && !Utility.isEmpty(longitude) && !Utility.isEmpty(latitude)) {
    const status = `<div class="row flex-wrap"><span class="pr-s">${details.punchAt ? moment(details.punchAt).format("hh:mm A") : "-"}</span><div class="row fs-m  pt-xs pb-xs pl-s pr-s border-radius-s data-grid-badge-color-6 text-green" style="width: auto;"><div class=" fs-r text-align-left  display-block " style="overflow-wrap: break-word;"}"><a class="cursor-hand" onclick="window.openSelectedLocation(${latitude},${longitude})">Coordinates</a></div></div></div>`;
    return status;
  }
  return `${details.punchAt ? moment(details.punchAt).format("hh:mm A") : "-"}`;
}

export function getClockOutLocationCoordinates(details) {
  const latitude = details.clockOutLatitude;
  const longitude = details.clockOutLongitude;
  if (details && !Utility.isEmpty(longitude) && !Utility.isEmpty(latitude)) {
    const status = `<div class="row flex-wrap"><span class="pr-s">${details.clockOut ? moment(details.clockOut).format("hh:mm A") : "-"}</span><div class="row fs-m  pt-xs pb-xs pl-s pr-s border-radius-s data-grid-badge-color-6 text-green" style="width: auto;"><div class=" fs-r text-align-left  display-block " style="overflow-wrap: break-word;"}"><a class="cursor-hand" onclick="window.openSelectedLocation(${latitude},${longitude})">Coordinates</a></div></div></div>`;
    return status;
  }
  return `${
    details.clockOut ? moment(details.clockOut).format("hh:mm A") : "-"
  }`;
}

export function contractorColumnConfig(contractorList) {
    let rowData = [];
    if (contractorList && contractorList.length > 0) {
        contractorList.forEach((employeeList, index) => {
            const row = {
              [COLUMN_CODE.PEOPLE_CONTRACTOR_LIST.EMPLOYEE_NAME]:
                getUserNameColumnForContractorList(employeeList),
              [COLUMN_CODE.PEOPLE_CONTRACTOR_LIST.TYPE]: "Contractor",
              [COLUMN_CODE.PEOPLE_CONTRACTOR_LIST.EMAIL_ID]:
                employeeList.emailId ? employeeList.emailId : "",
              [COLUMN_CODE.PEOPLE_CONTRACTOR_LIST.UNIQUE_ID]: getFieldValue(employeeList),
              [COLUMN_CODE.PEOPLE_CONTRACTOR_LIST.STATUS]:
                getEmpStatus(employeeList),
              [COLUMN_CODE.PEOPLE_CONTRACTOR_LIST.USER_ID]: employeeList.userId
                ? employeeList.userId
                : index,
              [COLUMN_CODE.PEOPLE_CONTRACTOR_LIST.ROLES]: employeeList.roles
                ? employeeList.roles
                : [],
            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function getUserNameColumnForContractorList(user) {
    let employeeColumn = CONSTANTS.EMPTY_STRING;
    employeeColumn += user.firstName;
    employeeColumn += user.lastName ? ` ${user.lastName}` : ``;
    return employeeColumn;
}

export function getFieldValue (object) {
    let contractorType = object["contractorType"] ? object["contractorType"] : "";
    let fieldToMask = "";
    if (contractorType === "INDIVIDUAL") {
        fieldToMask = object.socialSecurityNumber;
      } else if (contractorType === "BUSINESS") {
        fieldToMask = object.employerIdentificationNumber;
      }
      let maskedField = getMaskedInput(fieldToMask, 5, 4);
      return maskedField;
}

export function getMaskedInput(inputText, maskCount, normalText) {
    let maskedText = inputText;
    if (!Utility.isEmpty(maskedText)) {
        let maskedInput = "";
        let remainingText = "";
        remainingText = inputText.substring(maskCount, inputText.length);
        for(let i = 0; i< maskCount; i++) {
            maskedInput += "*"
        }
        maskedText = `${maskedInput}${remainingText}`;
    };
    return maskedText;
}

export function contractorPayrollColumnConfig(payrollList,isCashfreeEnabled, functionConfig, module) {
    let rowData = [];
    if (payrollList && payrollList.length > 0) {
        payrollList.forEach((payroll, index) => {
            const row = {
                [COLUMN_CODE.CONTRACTOR_PAYROLL.PAYDATE]: Utility.formatDate(payroll.payDate, FORMAT.MMDDYYYY_2),
                [COLUMN_CODE.CONTRACTOR_PAYROLL.TOTAL_COST]: FormatCurrencyService.format(payroll.totalCost ?? 0),
                [COLUMN_CODE.CONTRACTOR_PAYROLL.STATUS]: payroll.processed ? 'Processed' : 'Upcoming',
                [COLUMN_CODE.CONTRACTOR_PAYROLL.ID]: payroll._id ? payroll._id : index,
                processed: payroll.processed,
                rowContextMenu:getContextMenuForPayrollGrid(payroll,functionConfig, CONSTANTS.EMPTY_STRING, module)

            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function parseColumnConfigContractorPayrun(columnData) {
  columnData.forEach((column) => {
    column["key"] = column.columnCode;
    switch (column.columnCode) {
      case COLUMN_CODE.PAYROLL.TOTAL_COST:
        column.name = "Total Cost";
      case COLUMN_CODE.PAYROLL.PAYDATE:
      case COLUMN_CODE.PAYROLL.TOTAL_COST:
      case COLUMN_CODE.PAYROLL.STATUS:
        column.uiVisible = true;
        column.hidden = false;
        column.width = 250
        break;
      case COLUMN_CODE.PAYROLL.WORK_PERIOD:
      case COLUMN_CODE.PAYROLL.TOTAL_EARNINGS:
      case COLUMN_CODE.PAYROLL.EMPLOYER_COST:
      case COLUMN_CODE.PAYROLL.PAYMENT_STATUS:
        column.uiVisible = false;
        column.hidden = true;
        break;
    }
  });
  return columnData;
}

export function ContractorColumnConfigForProcessPayroll(employeePayrollList, isEditEnable) {
    let rowData = [];
    let incompleteProfiles = [];
    PayrollManager.otIds = []
    if (employeePayrollList && employeePayrollList.payrolls && employeePayrollList.payrolls.length > 0) {
        employeePayrollList.payrolls.forEach((payroll, index) => {
            const row = {
                [COLUMN_CODE.CONTRACTOR_PROCESS_PAYROLL.CONTRACTORS]: getUserNameInProcessPayroll(payroll),
                [COLUMN_CODE.CONTRACTOR_PROCESS_PAYROLL.TIME_WORKED]: getOTForProcessPayroll(payroll, isEditEnable),
                [COLUMN_CODE.PROCESS_PAYROLL.ADDITIONAL_EARNING]: getAdditionalEarning(payroll),
                [COLUMN_CODE.PROCESS_PAYROLL.NET_PAY]: `<div class="row" style="text-align:right"><span >${FormatCurrencyService.format(payroll.netPay)}</span></div>`,
                [COLUMN_CODE.PAYROLL.ID]: payroll._id ? payroll._id : index,
                [COLUMN_CODE.PROCESS_PAYROLL.PAYRUN_ID]: employeePayrollList._id ? employeePayrollList._id : index,
                [COLUMN_CODE.PROCESS_PAYROLL.EMPLOYEE_NAME]: payroll.firstName + CONSTANTS.EMPTY_STRING_WITH_SPACE + payroll.lastName
            };
            rowData.push(row);
        });
    }

    return {rowData, incompleteProfiles};
}

export function parseColumnConfigContractorProcessPayrun(columnData) {
  columnData.forEach((column) => {
    column["key"] = column.columnCode;
    switch (column.columnCode) {
      case COLUMN_CODE.PROCESS_PAYROLL.EMPLOYEE:
      case COLUMN_CODE.PAYROLL_SUMMARY.EMPLOYEE:
        column.name = "Contractors";
        column.uiVisible = true;
        column.hidden = false;
        column.width = 250;
        break;
      case COLUMN_CODE.PROCESS_PAYROLL.OVERTIME:
      case COLUMN_CODE.PAYROLL_SUMMARY.OVERTIME:
        column.name = "Time Worked";
      case COLUMN_CODE.PROCESS_PAYROLL.ADDITIONAL_EARNING:
      case COLUMN_CODE.PROCESS_PAYROLL.NET_PAY:
      case COLUMN_CODE.PAYROLL_SUMMARY.ADDITIONAL_EARNING:
      case COLUMN_CODE.PAYROLL_SUMMARY.NET_PAY:
        column.uiVisible = true;
        column.hidden = false;
        column.width = 250;
        break;
      case COLUMN_CODE.PROCESS_PAYROLL.DEDUCTION:
      case COLUMN_CODE.PAYROLL_SUMMARY.DEDUCTION:
        column.uiVisible = true;
        column.hidden = false;
        column.width = 250;
        break;
      case COLUMN_CODE.PROCESS_PAYROLL.EMPLOYEE_ID:
      case COLUMN_CODE.PROCESS_PAYROLL.LOP:
      case COLUMN_CODE.PROCESS_PAYROLL.EMPLOYER_CONTRIBUTION:
      case COLUMN_CODE.PAYROLL_SUMMARY.LOP:
      case COLUMN_CODE.PAYROLL_SUMMARY.EMPLOYER_CONTRIBUTION:
        column.uiVisible = false;
        column.hidden = true;
        break;
    }
  });
  return columnData;
}

function getUserNameInContractorProcessPayroll(payroll) {
  return `<div class="row mt-s" style="align-items:start">
    <div class="column"><div style="margin-bottom:0px">${getContractorColumDetails(
      payroll
    )}</div></div></div>`;
}

const getContractorColumDetails = (payroll) => {
  let employeeColumn = CONSTANTS.EMPTY_STRING;
  employeeColumn += `<div class="row" style="font-weight:bold">${payroll.firstName}`;
  employeeColumn += payroll.lastName ? ` ${payroll.lastName}` : ``;
  if(payroll.compensationPeriod === "hourly") {
      employeeColumn += `</div><div class="text-gray fs-r"><span style="font-weight:bold">${FormatCurrencyService.format(
        payroll.hourlyPay
      )}</span><span style="font-weight:bold">${
        CONSTANTS.PER_HOUR
      }</span></div>`;
  } else {
        employeeColumn += `</div><div class="text-gray fs-r"><span style="font-weight:bold">${FormatCurrencyService.format(
          payroll.basicPayrun
        )}</span><span style="font-weight:bold">${
          CONSTANTS.EMPTY_STRING
        }</span></div>`;
  }
  return employeeColumn;
};

function getRHForProcessPayroll(payroll, isEditEnable) {

    let otField = CONSTANTS.EMPTY_STRING
    otField = `<div style="display:grid">
        <div class="row mt-r">
            <div class="row" style="">
            <div  class = "column mr-l" style="width: 20%" >
            <div class="fs-r fw-m pb-4 ot-align" style="" > RH</div>
            </div>
            <div class="column  align-items-start" style="width: 28%;margin-left:4px">
                <div class="fs-r fw-m pb-4 ot-align" style="" > Rate</div>
            </div>
            <div class="column  align-items-start p-h-s" style="width: 30%; margin-left: 10px">
                <div class="fs-r fw-m pb-4 ot-align" style="" > Amount</div>
            </div>
            </div>

        </div>`;
    otField += getInputFieldForRH(payroll.hoursWorked, payroll._id, isEditEnable, payroll)

    return otField += `</div>`

}

const getInputFieldForRH = (workingHours, id, isEditEnabled, payrollData) => {
    const workingHourId = `workingHours_${id}`
    let isDisabled = !isEditEnabled ? "disabled" : "";
    const hourlyPay = payrollData && payrollData.hourlyPay ? payrollData.hourlyPay : 0;
    PayrollManager.rhIds.push(workingHourId);

    return `<div class="row m-v-r">
            <div class="row" style="">
            <div  class = "column" style="width: 20%" >
                <input id="${workingHourId}" type="number" class="incrementor-input fs-r parent-width overtime01" ${isDisabled} value='${workingHours}' style="padding-left:5px" />
            </div>
            <div class="column text-gray" style="margin-left:15px">
                <span>x</span>
            </div>

            <div class="column  align-items-start" style="width: 28%; margin-left:4px">
                    <span class=" text-gray d-flex align-items-center" style="height:30px;">${FormatCurrencyService.format(
                      hourlyPay
                    )}</span>
            </div>
            <div class="column text-gray" style="padding-right:10px">
                <span class="">=</span>
            </div>
            <div class="column  align-items-start" style="width: 32%">
                    <span class=" text-gray d-flex align-items-center" style="height:30px;">${FormatCurrencyService.format(
                      workingHours * hourlyPay
                    )}</span>
            </div>
            </div>

        </div>`;
}

const getLOPForProcessPayroll = (payroll, isEditEnable) => {
  let otField = CONSTANTS.EMPTY_STRING;
  otField = `<div style="display:grid;">`;
  otField += getInputFieldForLOP(
    payroll.daysOff,
    payroll._id,
    isEditEnable,
    payroll,
    payroll.lossOfPay
  );
  return (otField += `</div>`);
};

const getInputFieldForLOP = (daysOff, id, isEditEnabled, payrollData, lossOfPay) => {
  const lossOfPayId = `lossOfPay_${id}`;
  let isDisabled = !isEditEnabled || (isIndiaCompliance() && payrollData.compensationPeriod === 'hourly') ? "disabled" : "";
  const hourlyPay =
    payrollData && payrollData.basicPayForDay ? payrollData.basicPayForDay : 0;
  PayrollManager.lopIds.push(lossOfPayId);

  return `<div class="row m-v-r">
            <div class="row" style="">
            <div  class = "column" style="width: 30%" >
                <input id="${lossOfPayId}" type="number" class="incrementor-input fs-r parent-width overtime01" ${isDisabled} value='${daysOff}' style="padding-left:5px" />
            </div>
            </div>

        </div>`;
};
export function filedNameByColumnCode(column,tableName, locationColumnName) {
    let filedName = column;
    switch(tableName){
        case TABLES.EMPLOYEE_LIST:
            switch(column){
                case 'compensation':
                    if(isIndiaCompliance()){
                        filedName =  'ctc';
                    }
                    break;
                case locationColumnName:
                    filedName = 'locationValue';
                    break;
            }
            break;
    }
    return filedName
}

export const DOCUMENT_STATUS = {
    INCOMPLETE: "Incomplete",
    DOWNLOAD: "Ready for Download",
    SIGNED: "Signed"
}

export function getDocumentColumnConfig(userId, documents, functionConfig) {
  const isAdmin = TenantService.get(TENANT.IS_ADMIN);
  const iamUserId = TenantService.get(TENANT.IAM_USER_ID);

  let rowData = [];
  if (documents && documents.length > 0) {
    const filterStr = `Form-16`;
    let form16List = documents?.filter(doc=>(doc?.name?.includes(filterStr))) || []
    let docList = documents?.filter(doc=>(!doc?.name?.includes(filterStr))) || []
    form16List = form16List?.filter(form=>!Utility.isEmpty(form?.path) && form?.isDefault) || []
    const newDoc = [...form16List, ...docList ];
    newDoc?.forEach((document, index) => {
      const row = {
        id: document.id,
        key: document.key,
        isDefault: document.isDefault,
        path: document.path,
        [COLUMN_CODE.PEOPLE_DOCUMENT.DOCUMENT_NAME]: document.name,
        [COLUMN_CODE.PEOPLE_DOCUMENT.STATUS]: DOCUMENT_STATUS_MAP[
          document.status
        ]
          ? DOCUMENT_STATUS_MAP[document.status].status
          : document.status,
        [COLUMN_CODE.PEOPLE_DOCUMENT.DESCRIPTION]: DOCUMENT_STATUS_MAP[
          document.status
        ]
          ? getUploadedOn(document)
          : CONSTANTS.EMPTY_STRING,
        rowContextMenu: getDocumentFunctionalConfig(userId, document, functionConfig, isAdmin, iamUserId),
      };
      rowData.push(row);
    });
  }
  return rowData;
}
export function getSalaryHistoryColumnConfig(history) {
    let rowData = [];
    if (history && history.length > 0) {
        history.forEach((h, index) => {
            const row = {
                action: getAction(h.action),
                updatedByName: `<div class="fw-b">${h.updatedByName}</div>`,
                updatedAtDate: !Utility.isEmpty(h.updatedAtDate) ? new Date(h.updatedAtDate) : "",
                log: getLog(h.log),
            };
            rowData.push(row);
        });
    }
    return rowData;
}

const getAction = (action) => {
    if (action) {
        return (
            `<table>
                ${action.map((a) => {
                return (
                    `<tr><td>${a}</td></tr>`
                )
            }).join("")
            }
            </table`
        )
    }
}

const getLog = (logArray) => {
    if (logArray) {
        return (
            `<table>
                ${logArray.map((element) => {
                return (
                    Object.entries(element).map(([key, value]) => {
                        return (
                            `<tr>
                            <td class="fw-b">${LOG_MAP[key]}:</td><td>${getLogValue(element.field, key, value)}</td>
                            </tr>`
                        )
                    }).join("")
                )
            }).join("")
            }              
            </table>`
        )
    }
}
const getLogValue = (field, key, value) => {
    if (key === "field") {
        return value;
    }
    let formattedValue = "";
    switch (field) {
        case "CTC/Wages":
            formattedValue = `<span className="fw-m">${FormatCurrencyService.format(value)}</span>`
            break;
        case "Period":
            formattedValue = PERIOD_MAP[value] ?? "N/A";
            break;
        case "Effective Date":
        case "Termination Date":
        case "Rehire Date":
            formattedValue = !Utility.isEmpty(value) ? Utility.formatDate(new Date(value), FORMAT.YYYYMMDD) : "N/A";
            break;
        default:
            formattedValue = !Utility.isEmpty(value) ? value : "N/A";
    }
    return formattedValue;
}

export function getDocumentFunctionalConfig(userId, data, config, isAdmin, iamUserId) {
    const documentOwner = data.owner && typeof data.owner === "number" ? String(data.owner) : data.owner;

    if (data) {
        if (DEFAULT_US_FORMS[data.key]?.isDefault) {
            const buttons = [];
            const uploadSigned = {
                title: "Upload Signed",
                icon: ic_upload,
                className: "",
                onClick: (data) => {
                    config.uploadSigned(data, true);
                },
            };
            buttons.push(uploadSigned);

            const downloadSigned = {
                title: "Download Signed",
                icon: DKIcons.ic_download,
                onClick: (data) => {
                    config.downloadSigned(data, true);
                },
            };
            buttons.push(downloadSigned);

            return buttons;
        } else if (!data.isDefault) {
            const buttons = [];

            if (isAdmin || iamUserId === documentOwner) {
                buttons.push({
                    title: "Upload and Replace",
                    icon: ic_upload,
                    className: "",
                    onClick: (data) => {
                        config.uploadAndReplace(data, false, true);
                    },
                });
            }

            if (data.status !== "READ_AND_ACCEPT" && userId === TenantService.get(TENANT.USER_ID)) {
                buttons.push({
                    title: "Read and Accept",
                    icon: ic_check_mark,
                    className: "",
                    onClick: (data) => {
                        config.readAndAccept(data);
                    },
                });
            }

            if (isAdmin || iamUserId === documentOwner) {
                buttons.push({
                    title: "Delete Document",
                    icon: DKIcons.ic_delete,
                    onClick: (data) => {
                        config.deleteDocument(data, false);
                    },
                });
            }

            return buttons;
        } else {
            return null;
        }
    }
}

export function ExpenseClaimsColumnConfig(expenses, onContextMenuAction, isAdmin, userId) {
    let rowData = [];
    if (expenses && expenses.length > 0) {
        expenses.forEach((expense) => {
            const exp = deepClone(expense);
            const multilevelApproval = getApprovalStatus(exp['approvalStages']);
            const status = (multilevelApproval && multilevelApproval.status && expense.status === EXPENSE_CLAIM_STATUS.PENDING) ? multilevelApproval.status : expense.status
            const row = {
                ["id"]: expense.id,
                [COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.EXPENSE_ID]: expense.code,
                [COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.CATEGORY]: expense.category,
                [COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.DATE]: Utility.formatDate(expense.spendDate, FORMAT.YYYYMMDD),
                [COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.APPLICANT]: expense.userName,
                [COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.EXPENSE_GROUP]: expense.groupName,
                [COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.MERCHANT]: extractTextFromHTML(stringSanitizer(expense.merchant)),
                [COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.TOTAL_AMOUNT]: expense.totalAmount,
                [COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.STATUS]: getExpeseStatus(expense),
                [COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.GROUP]:expense.expenseGroup,
                [COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.DESCRIPTION]:expense[COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.DESCRIPTION],
                ['statusValue']: status,
                ['isMultilevelApproval']: expense['approvalStages'] && multilevelApproval ? true : false,
                ["rowContextMenu"]: getContextMenuForExpenseGrid(expense, onContextMenuAction, isAdmin, userId),
                ['nonEditableColumns']: ((expense.status == EXPENSE_CONSTANTS.DRAFT) && (userId === expense.userId || isAdmin)) ? []:[COLUMN_CODE.PEOPLE_EXPENSE_CLAIMS.GROUP],
                ['data']: expense
            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function getUploadedOn(document) {
    let description = "";
    if (document.status === "UPLOADED_DOCUMENT" || document.status === "READ_AND_ACCEPT") {
        let uploadedOn = document.uploadedOn ? moment(document.uploadedOn).format("MM-DD-YYYY") : "";
        uploadedOn = Utility.formatDate(uploadedOn, "MM-DD-YYYY", "");
        description = `${
          DOCUMENT_STATUS_MAP[document.status].description
        } ${uploadedOn}`;
    } else {
        description = DOCUMENT_STATUS_MAP[document.status].description;
    }
    return description;
}
export function sortColumnMapping(column) {
    switch(column.columnData.columnCode) {
        case "name":
            return 'meta.firstName';
        case "compensation":
        case "ctc":
            return "meta.compensation";
        default:
            return column.columnData.columnCode;
    }
}

export function parseExpenseColumnConfig(columnData, isSync) {
  columnData.forEach((column) => {
    switch (column.columnCode) {
      case COLUMN_CODES.DATE_OF_JE:
        column.editable = isSync;
        break;
      case COLUMN_CODES.DATE_OF_REVERSAL_JE:
        column.editable = !isSync;
        column.uiVisible = !isSync;
        column.hidden = isSync;
        break;
    }
  });
  return columnData;
}

export function ExpenseSyncRevertColumnConfig(expenses, isSync) {
  let rowData = [];
  if (expenses && expenses.length > 0) {
    expenses.forEach((expense) => {
      const row = {
        [COLUMN_CODE.PEOPLE_EXPENSE_SYNC_REVERT_JE.EXPENSE_ID]: expense.code,
        [COLUMN_CODE.PEOPLE_EXPENSE_SYNC_REVERT_JE.CATEGORY]: expense.category,
        [COLUMN_CODE.PEOPLE_EXPENSE_SYNC_REVERT_JE.DATE]: Utility.formatDate(
          expense.spendDate,
          FORMAT.YYYYMMDD
        ),
        [COLUMN_CODE.PEOPLE_EXPENSE_SYNC_REVERT_JE.APPLICANT]: expense.userName,
        [COLUMN_CODE.PEOPLE_EXPENSE_SYNC_REVERT_JE.EXPENSE_GROUP]:
          expense.groupName,
        [COLUMN_CODE.PEOPLE_EXPENSE_SYNC_REVERT_JE.MERCHANT]: expense.merchant,
        [COLUMN_CODE.PEOPLE_EXPENSE_SYNC_REVERT_JE.TOTAL_AMOUNT]:
          expense.totalAmount,
        [COLUMN_CODE.PEOPLE_EXPENSE_SYNC_REVERT_JE.DATE_OF_JE]: new Date(),
        [COLUMN_CODE.PEOPLE_EXPENSE_SYNC_REVERT_JE.DATE_OF_REVERSAL_JE]: !isSync
          ? new Date()
          : "",
        ["data"]: expense,
        ["id"]: expense.id,
      };
      rowData.push(row);
    });
  }
  return rowData;
}

export function getContextMenuForExpenseGrid(exp, onContextMenuAction, isAdmin, userId) {
    const contextMenu = [];
    const { tenant } = TenantManager.getPeopleTenantData();
    let expense = deepClone(exp);
    let multilevelApproval = getApprovalStatus(expense['approvalStages'])
    
    let status = (multilevelApproval && multilevelApproval.status && expense.status === EXPENSE_CLAIM_STATUS.PENDING) ? multilevelApproval.status : expense.status
    const approve = {
        title: "Approve",
        icon: ic_check_mark,
        onClick: (data) => {
            onContextMenuAction(EXPENSE_CONSTANTS.APPROVE, data);
        }
    }
    const reject = {
        title: "Reject",
        icon: ic_close,
        onClick: (data) => {
            onContextMenuAction(EXPENSE_CONSTANTS.REJECT, data);
        }
    }
    const duplicate = {
        title: "Duplicate",
        icon: ic_copy,
        onClick: (data) => {
            onContextMenuAction(EXPENSE_CONSTANTS.DUPLICATE, data);
        }
    }
    const isApprove = PermissionUtils.hasAccess(MODULE.EXPENSE_CLAIM,[ACTION.APPROVE])
    const isReject = PermissionUtils.hasAccess(MODULE.EXPENSE_CLAIM,[ACTION.REJECT])
    const isSubmit = PermissionUtils.hasAccess(MODULE.EXPENSE_CLAIM,[ACTION.SUBMIT])
    const isEdit = PermissionUtils.hasAccess(MODULE.EXPENSE_CLAIM,[ACTION.EDIT])
    const isDelete = PermissionUtils.hasAccess(MODULE.EXPENSE_CLAIM,[ACTION.DELETE])
    const isPrint = PermissionUtils.hasAccess(MODULE.EXPENSE_CLAIM,[ACTION.PRINT])
    const isHiringAdmin = TenantService.get(TENANT.IS_HIRING_ADMIN);
    switch (status) {
        case "PENDING":
            if(Utility.isEmpty(expense['isActionDisabled'])) {
                if(expense['approvalStages']) {
                    if(multilevelApproval) {
                        contextMenu.push(approve);
                        contextMenu.push(reject);
                    }
                } else {
                    if (isAdmin) {
                        contextMenu.push(approve);
                        contextMenu.push(reject);
                    } else if(!isHiringAdmin) {
                        if(isApprove) {
                            contextMenu.push(approve);
                        }
                        if(isReject) {
                            contextMenu.push(reject);
                        }
                    }
                }
            }
            if((isAdmin || userId === expense.userId) || multilevelApproval) {
                contextMenu.push(duplicate);
            }
            break;
        case "DRAFT":
            if(isEdit || userId === expense.userId) {
                contextMenu.push(
                    {
                        icon: DKIcons.ic_edit,
                        title: "Edit",
                        className:'p-0 text-app fw-m text-underline',
                        onClick: (data) => {
                            onContextMenuAction(EXPENSE_CONSTANTS.EDIT, data);
                        }
                    }
                );
            }
            if (userId === expense.userId) {
                contextMenu.push(
                    {
                        title: "Submit",
                        icon: ic_save,
                        onClick: (data) => {
                            onContextMenuAction(EXPENSE_CONSTANTS.SUBMITTED, data);
                        }
                    }
                );
            }
            if((isAdmin || userId === expense.userId)|| multilevelApproval) {
                contextMenu.push(duplicate);
            }
            break;
        }

        if(isDelete || userId === expense.userId) {
            contextMenu.push(
                {
                    title: "Delete",
                    icon: ic_delete,
                    onClick: (data) => {
                        onContextMenuAction(EXPENSE_CONSTANTS.DELETE, data);
                    }
                }
            );
        }

        if(isPrint || userId === expense.userId) {
            contextMenu.push(
                {
                    title: "Print",
                    icon: ic_printer,
                    onClick: (data) => {
                        onContextMenuAction(EXPENSE_CONSTANTS.PRINT, data);
                    }
                }
            );
        }

    return contextMenu;
}
export function ExpenseGroupColumnConfig(expenses, functionConfig) {
    let rowData = [];
    if (expenses && expenses.length > 0) {
        expenses.forEach((expense) => {
            const row = {
                [COLUMN_CODE.PEOPLE_EXPENSE_GROUP.NAME]: expense.name,
                [COLUMN_CODE.PEOPLE_EXPENSE_GROUP.MEMBER_COUNT]: expense.memberCount ? `${expense.memberCount} ${expense.memberCount && expense.memberCount.length >1 ? "Members": "Member"} ` :"<span class='text-red'>0 Members</span>",
                ['data']: expense,
                rowContextMenu:getContextMenuForExpenseGroupGrid(expense, functionConfig),
            };
            rowData.push(row);
        });
    }
    return rowData;
}
export function ExpenseGroupUserColumnConfig(expenses) {
    let rowData = [];
    if (expenses && expenses.length > 0) {
        expenses.forEach((expense) => {
            const row = {
                [COLUMN_CODE.PEOPLE_EXPENSE_GROUP_USER.NAME]: `${expense.firstName} ${expense.lastName}`,
                [COLUMN_CODE.PEOPLE_EXPENSE_GROUP_USER.ROLE]: (expense.role=="admin" ? ("Admin"): ((expense.role=="employee") ? "Member":"Manager")),
                ['data']: expense
            };
            rowData.push(row);
        });
    }
    return rowData;
}
export function ExpenseCategoryColumnConfig(expenses) {
    let rowData = [];
    if (expenses && expenses.length > 0) {
        expenses.forEach((expense) => {
            const row = {
                [COLUMN_CODE.PEOPLE_EXPENSE_CATEGORY.NAME]: expense.name,
                [COLUMN_CODE.PEOPLE_EXPENSE_CATEGORY.GROUP_NAME]: expense.groups ? expense.groups.map(res=> res.name).join(', ') : '',
                ['data']: expense
            };
            rowData.push(row);
        });
    }
    return rowData;
}
export function updateRowAttendanceSetting(rowData, rowObj, index) {
    
    let row = {

        [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.EMPLOYEE_NAME]: getEmployeeList(rowData, rowObj.isApplicableToAll, index),
        [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.LOCATION_NAME]: (rowObj.name?rowObj.name:(rowObj.locationName?rowObj.locationName:"")),
        [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.COORDINATES]: getCoordinatesJSON(rowData,index),
        [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.RADIUS]: rowObj.radius,
        [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.CLOCK_IN]: '00:00',
        [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.CLOCK_OUT]: '00:00',
        [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.STATUS]: rowObj.status,
        [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.IS_APPLICABLE_TO_ALL]: rowObj.isApplicableToAll,
        ['employees']:rowObj.employees,
        ['coordinatesList']:rowObj.coordinatesList,
        ['data']:rowObj&&rowObj.data ? rowObj.data : rowObj,
        'invalidFields': []
    };
    rowData[index]=row
    return rowData;
}
export function attendanceSettingGrid(rowData) {
    let resData = []
    rowData.forEach((row,index)=>{
        if(row.latitude) {
            rowData[index]['coordinatesList'] = [{lat:parseFloat(row.latitude), lng:parseFloat(row.longitude),address:row.address}]
        }
        
        const obj = {
            [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.EMPLOYEE_NAME]: getEmployeeList(row,row.applicableToAll,index),
            [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.LOCATION_NAME]: row.locations.map(loc=>loc.id) ,
            [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.COORDINATES]: getCoordinatesJSON(rowData,index),
            [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.RADIUS]: row.radius ? row.radius:0,
            [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.CLOCK_IN]: '00:00',
            [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.CLOCK_OUT]: '00:00',
            [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.STATUS]: row.active ?  ['active']:['inactive'],
            [COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.IS_APPLICABLE_TO_ALL]: row.applicableToAll,
            ['coordinatesList']:row.latitude ? [{lat:parseFloat(row.latitude), lng:parseFloat(row.longitude),address:row.address}]:[],
            ['employees']:row.users.map(u=>u.iamUserId),
            'invalidFields': [],
            ['data']:row
        };
        resData.push(obj);
    })
    
    return resData;
}
export function getCoordinatesJSON(rowData,index) {
    let ind = index!=null ? index : rowData.length
    let data = `<div class="parent-width parent-height" id=attendance_setting_location_${(ind)}>`;
    if (rowData && rowData[index]&&rowData[index].coordinatesList && rowData[index].coordinatesList.length != 0) {
        rowData[index].coordinatesList.forEach((c, i) => {
            data += `<div class="">${i + 1}. <b id=attendance_setting_location_${(ind)}>${c.address?c.address:"Location"}</b> <span class="fs-r">(<span class="text-app fw-m cursor-hand" id=attendance_setting_location_${(ind)}>Change</span>)</span><ul><li><div class="d-flex" id=attendance_setting_location_${(ind)}><b id=attendance_setting_location_${(ind)}>${i18next.t("LATITUDE")}</b>: ${c.lat}</div></li><li><div class="d-flex" id=attendance_setting_location_${(ind)}><b id=attendance_setting_location_${(ind)}>${i18next.t("LONGITUDE")}</b>: ${c.lng}</div></li></ul></div>`
        })
    } else {
        data += i18next.t("SELECT_LOCATION")
    }

    data += '</div>'
    return data;
}
export function getEmployeeList(rowData, isApplicableToAll, index) {
    return `<div class=" parent-width parent-height"> ${isApplicableToAll ? i18next.t("ALL_EMPLOYEES") : i18next.t("SPECIFIC_EMPLOYEE")} <span class="fs-r">(<span class="text-app fw-m cursor-hand" id=attendance_setting_emp_${(index!=null ? index : rowData.length)}>Change</span>)</span></div>`
}
export function geoLocationMapping(rowData) {
    let data = []
    rowData?.forEach(row=>{
        let obj = {
            [COLUMN_CODE.PEOPLE_LOCATION_EMPLOYEE_MAPPING.NAME]:row.name,
            [COLUMN_CODE.PEOPLE_LOCATION_EMPLOYEE_MAPPING.ADDRESS]:row.address,
            [COLUMN_CODE.PEOPLE_LOCATION_EMPLOYEE_MAPPING.LATITUDE]:row.latitude,
            [COLUMN_CODE.PEOPLE_LOCATION_EMPLOYEE_MAPPING.LONGITUDE]:row.longitude,
            [COLUMN_CODE.PEOPLE_LOCATION_EMPLOYEE_MAPPING.RADIUS]:row.radius,
            [COLUMN_CODE.PEOPLE_LOCATION_EMPLOYEE_MAPPING.ACTIVE]:row.active?[true]:[false],
            'invalidFields': [],
            ['coordinatesList']:row.latitude ? [{lat:parseFloat(row.latitude), lng:parseFloat(row.longitude),address:row.address}]:[],
            ['data']:row
        }
        data.push(obj);
    })
    return data;
}
export function getOvertimeRowData(rowData) {
    let data = []
    rowData?.forEach(row=>{
        let obj = {
            [COLUMN_CODE.PEOPLE_OVERTIME_LIST.POLICY_NAME]:row.policyName,
            [COLUMN_CODE.PEOPLE_OVERTIME_LIST.STATUS]:(row.status == 'ACTIVE')?['ACTIVE']:['DRAFT'],
            [COLUMN_CODE.PEOPLE_OVERTIME_LIST.POLICY_DESCRIPTION]:row.description,
            [COLUMN_CODE.PEOPLE_OVERTIME_LIST.EMPLOYEES]:row.applicableToAll ? "Applicable to All employee" : (row.employeeDetails?.length != 0 ? getEmployeesList(row.employeeDetails): "-") ,
            'invalidFields': [],            
            ['data']:row
        }
        data.push(obj);
    })
    return data;
}
export function getEmployeesList(employees) {
     
    let employeesDetails = employees.slice(0, SHOW_MINIMUM_NO_LIST).map((e) => `${e.firstName} ${e.lastName}`).join(", ");
                employeesDetails += employees.length > SHOW_MINIMUM_NO_LIST ? `... and ${employees.length - SHOW_MINIMUM_NO_LIST} more` : "";
                return employeesDetails;
}
export function getLocationRowData(tableList, functionConfig) {
  let rowData = [];
  tableList.forEach((tableData, index) => {
    const row = {
      [COLUMN_CODE.PEOPLE_LOCATION_LIST.NAME]: tableData.label,
      [COLUMN_CODE.PEOPLE_LOCATION_LIST.TITLE]:
        tableData?.locationDetails?.title,
      [COLUMN_CODE.PEOPLE_LOCATION_LIST.EMAIL]:
        tableData?.locationDetails?.email,
      [COLUMN_CODE.PEOPLE_LOCATION_LIST.PHONE]:
        tableData?.locationDetails?.phone,
      [COLUMN_CODE.PEOPLE_LOCATION_LIST.ADDRESS]: getFormattedAddress(
        tableData?.locationDetails?.address
      ),
      rowButtons: getButtonsForRow(tableData, functionConfig, false),
      locationDetails: tableData.locationDetails,
      id: tableData.id,
    };
    rowData.push(row);
  });

  return rowData;
};

export function getFormattedAddress(address){
  const { line1, line2, cityAndState, countryAndPostalCode } =
    Utility.getFormattedAddressObj(address);

  let formattedAddress = "";
  if (!Utility.isEmpty(line1)) {
    formattedAddress += line1 + ", ";
  }
  if (!Utility.isEmpty(line2)) {
    formattedAddress += line2 + ", ";
  }

  if (!Utility.isEmpty(cityAndState)) {
    formattedAddress += cityAndState + ", ";
  }

  if (!Utility.isEmpty(countryAndPostalCode)) {
    formattedAddress += countryAndPostalCode;
  }

  return formattedAddress;
};
export function insertRowIntoMultiClaim(rowData) {
    
    
    const row = {
                
        [COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.EXPENSE_ID]:null,
        [COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.DATE]: new Date(),
        [COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.MERCHANT]: '',
        [COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.TAX_AMOUNT]: 0,
        [COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.TAX_CODE]: null,
        [COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.TOTAL_AMOUNT]: 0,
        [COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.OTHER_DETAILS]: '',
        [COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.CATEGORY_ID]: null,
        [COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.ATTACHMENTS]: null,
        [COLUMN_CODE.PEOPLE_MULTIPLE_EXPENSE.DESCRIPTION]:'',
        'invalidFields':[],
    };
    rowData.push(row);
    return rowData;
}

const getButtonsForRow = (tableData, functionConfig, isContextMenu) => {
  let buttons= [];
  buttons.push({
    title: "Edit",
    className: "p-v-0 text-blue underline grid-action-link-h-padding",
    onClick: (data) => {
        functionConfig.editRow(data);
    },
    icon: isContextMenu ? DKIcons.ic_edit : null,
  });
  return buttons;
};

export function getLocationValueAndLabel(tenantDetails){
    let isLocationActive = false;
    let locationLabel = "";
    const additionalSettings = tenantDetails
      ? tenantDetails.additionalSettings
      : "";
    const locationSettings = additionalSettings
      ? additionalSettings?.["LOCATION"]
      : {};
    isLocationActive = locationSettings?.trackLocation || false;
    locationLabel = isLocationActive
      ? locationSettings?.locationLabel
      : "";

    return { isLocationActive, locationLabel };
}

export function AssessmentReviewColumnConfig(assessmentReviews) {
    let rowData = [];
    if (assessmentReviews && assessmentReviews.length > 0) {
        assessmentReviews.forEach((assessment) => {
            const row = {
                id: assessment.iamUserId,
                data: assessment,
                [COLUMN_CODE.PEOPLE_ASSESSMENT_REVIEW.NAME]: assessment.appraisee? `<span class="fw-b">${assessment.appraisee?.firstName} ${assessment.appraisee?.lastName}<span>`:'',
                [COLUMN_CODE.PEOPLE_ASSESSMENT_REVIEW.SELF_ASSESSMENT_STATUS]: assessment.appraiseeSubmissionStatus ? "Complete" : "Incomplete",
                [COLUMN_CODE.PEOPLE_ASSESSMENT_REVIEW.APPRAISER_ASSESSMENT_STATUS]: assessment.appraiserSubmissionStatus ? "Complete" : "Incomplete",
                [COLUMN_CODE.PEOPLE_ASSESSMENT_REVIEW.ACTION]: assessment.appraiseeSubmissionStatus && !assessment.appraiserSubmissionStatus && isValidReviwer(assessment) ? getAssessmentReviewButton(assessment) : ""
            };
            rowData.push(row);
        });
    }
    return rowData;
}
export function isValidReviwer (rowData) {
    const iamUserId = TenantService.get(TENANT.IAM_USER_ID)
    const isAdmin = TenantService.get(TENANT.IS_ADMIN);
    if ((rowData.appraisee.iamUserId === parseInt(iamUserId)) && (!isAdmin)) {
        return false;
    } else {
        return true;
    }
}

export function irasReportGenerate(irasData) {
    let rowData = [];
    if (irasData && irasData.length > 0) {
        irasData.forEach((data) => {
            const row = {
                
                [COLUMN_CODE.PEOPLE_IRAS_SUMMARY_REORT.userId]: data.userId,
                [COLUMN_CODE.PEOPLE_IRAS_SUMMARY_REORT.employeeName]: data.employeeName,
                [COLUMN_CODE.PEOPLE_IRAS_SUMMARY_REORT.totalBasicPay]: FormatCurrencyService.format(data.totalBasicPay),
                [COLUMN_CODE.PEOPLE_IRAS_SUMMARY_REORT.bonus]: FormatCurrencyService.format(data.categories.find(category=>category.name === 'Bonus')?.amount),
                [COLUMN_CODE.PEOPLE_IRAS_SUMMARY_REORT.directorsFee]: FormatCurrencyService.format(data.categories.find(category=>category.name === "Director's fees")?.amount) ,
                [COLUMN_CODE.PEOPLE_IRAS_SUMMARY_REORT.cpfContribution]: FormatCurrencyService.format(getCPFContribution(data)),
                [COLUMN_CODE.PEOPLE_IRAS_SUMMARY_REORT.donation]: FormatCurrencyService.format(data.donation),
                [COLUMN_CODE.PEOPLE_IRAS_SUMMARY_REORT.mosque]: FormatCurrencyService.format(getFundAmount(data)),
                [COLUMN_CODE.PEOPLE_IRAS_SUMMARY_REORT.other]: FormatCurrencyService.format(data.categories.find(category=>category.name === 'Others')?.amount),
                [COLUMN_CODE.PEOPLE_IRAS_SUMMARY_REORT.totalData]: data
            };
            rowData.push(row);
        });
    }
    return rowData;
}
function getCPFContribution(rowData) {
    let amount = 0;
    const compliance = rowData.compliance;
    if (compliance && compliance.employeeContribution) {
        const contribution = compliance.employeeContribution;
        if (contribution && contribution['cpfContribution']) {
            amount = contribution['cpfContribution'];
        }
    }
    return amount;
}
function getFundAmount(rowData) {
    let amount = 0;
    const compliance = rowData.compliance;
    if (compliance && compliance.employeeContribution) {
        const contribution = compliance.employeeContribution;
        if (contribution && contribution['mbmf']) {
            amount = contribution['mbmf'];
        }
    }
    return amount;
}

function getAssessmentReviewButton(assessment) {
    return (
        `<div class="row p-h-m">
            <div class="d-flex dk-button-hover cursor-hand" onclick="window.navigateToAdminReview('${Utility.encodeJSON(assessment)}')">
                <text class="text-app fs-r fw-m text-underline">Review</text>
            </div>
        </div>`
    );
}

function getContributionName(name) {
    switch(name) {
        case "cpfContribution":
            return "CPF"
        case "employerSDL":
            return "SDL";
        case "employerFWL":
            return "FWL";
        case "sinda":
        case "mbmf":
        case "cdac":
        case "ecf":
        case "eis":
        case "epf":
        case "mtd":
        case "socso":
        case "hrdf":
            return name.toUpperCase();
        default:
        return name;
    }
}

export function PaymentLogsColumnConfig(paymentLogs) {
    let rowData = [];
    if (paymentLogs?.length > 0) {
        paymentLogs.forEach((payment) => {
            const row = {
                [COLUMN_CODE.PEOPLE_PAYMENT_LOGS.DATE]: payment.payDate,
                [COLUMN_CODE.PEOPLE_PAYMENT_LOGS.BATCH_ID]: payment.batchId,
                [COLUMN_CODE.PEOPLE_PAYMENT_LOGS.BANK]: payment.bank,
                [COLUMN_CODE.PEOPLE_PAYMENT_LOGS.PAY_PERIOD]: payment.payPeriodFromDate || "-",
                [COLUMN_CODE.PEOPLE_PAYMENT_LOGS.ACCOUNT_NUMBER]: payment.accountNumber,
                data: payment
            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function aisSummaryColumnConfig(employee, functionConfig, view) {
    let rowData = [];
    if(!Utility.isEmpty(employee?.length)) {
        employee.forEach(element => {
            const row = {
                ...element,
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION.EMPLOYEE_ID]: getSubmittedIcon(element,"IR8A", view),
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION.EMPLOYEE_NAME]: `${element.firstName} ${element.lastName}`,
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION.UNIQUE_ID]: !Utility.isEmpty(element.nric) ? getMaskedInput(element.nric, 6, 0) : getMaskedInput(element.fin, 6, 0),
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION.DESIGNATION]: element.designation,
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION.IR8A] : getFormStatus(element, "IR8A"),
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION.IR8S] : getFormStatus(element, "IR8S"),
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION.APPENDIX8A] : getFormStatus(element, "APPENDIX 8A"),
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION.APPENDIX8B] : getFormStatus(element, "APPENDIX 8B"),
                empId: element.employeeId,
                rowContextMenu: getContextMenuForIRASSubmission(element,"IR8A", functionConfig),
            }
            rowData.push(row);
        });
    }
    return rowData;
}

export function getFormStatus (employee, formName) {
    let formStatus = employee?.formStatus;
    let isGenerated = false;
    if(!Utility.isEmptyObject(formStatus)) {
        let index = formStatus.findIndex(x=> x.type === formName);
        if(index != -1) {
            const formConfig = formStatus[index];
            isGenerated = formConfig.isGenerated;
        }
        if(isGenerated) {
            return `<div class="parent-width justify-content-center d-flex"><img class="ic-s justify-content-center cursor-hand"" src= ${ic_check_mark} /></div>`
        }
    }
}

export function aisSummaryLogsColumnConfig(employee, functionConfig,cpfAccountData) {
    let rowData = [];
    if(!Utility.isEmpty(employee?.length)) {
        employee.forEach(element => {
            const row = {
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION_LOGS.FILE_NAME]:element.fileName,
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION_LOGS.CPF_ACCOUNT]: getCPFAccountName(cpfAccountData, element.cpfAccountId),
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION_LOGS.YEAR]: element.year,
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION_LOGS.EMPLOYEES]: element.noOfRecords,
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION_LOGS.SUBMISSION_DATE] : element.submissionDate,
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION_LOGS.ACTION] : element.action,
                [COLUMN_CODE.PEOPLE_AIS_SUBMISSION_LOGS.RESULT] : element.status == 'FAILURE' ? 'Failed':'Successful',
                rowContextMenu: getContextMenuForSubmissionLogs(element,functionConfig),
                ...element
            }
            rowData.push(row);
        });
    }
    return rowData;
}

function getContextMenuForSubmissionLogs(log,functionConfig) {

    let action = []
    if(log.responseFilePath) {
        action.push({
            title: "Response File",
            icon: ic_file_green,
            onClick: (data) => {
              functionConfig.downloadResponse(data);

            }
        })

    }
    if(log.requestFilePath) {
        action.push({
            title: "Input File",
            icon: ic_file_blue,
            onClick: (data) => {
              functionConfig.downloadInputFile(data);

            }
        })
    }

    return action
}

export function getCPFAccountName(accountDetails, cpfAccount) {
    let accountName = CONSTANTS.EMPTY_STRING;
    if(accountDetails?.accounts?.length > 0) {
        const accountIndex = accountDetails.accounts.findIndex(f=> f.accountId === cpfAccount);
        if(accountIndex != -1) {
            const account = accountDetails.accounts[accountIndex];
            accountName = account?.compliance?.name;
        }
    }
    return accountName
}

export function ShiftsColumnConfig(shifts) {
    let rowData = [];
    if (shifts && shifts.length > 0) {
        shifts.forEach((shift) => {
            const row = {
                id: shift.id,
                data: shift,
                name: shift.name,
                from: moment(shift.from, "HH:mm").format("hh:mm A"),
                to: moment(shift.to, "HH:mm").format("hh:mm A"),
                shiftMargin: shift.shiftMargin ? `Before: ${shift.shiftMarginBefore} Hrs<br/>After: ${shift.shiftMarginAfter} Hrs` : "",
                reqdHrsToMarkPresent: `${shift.reqdHrsToMarkPresent} Hrs`,
                reqdHrsToMarkHalfPresent: `${shift.reqdHrsToMarkHalfPresent} Hrs`,
                applicableTo: ShiftUtils.getEmployeeDetailsConfig(shift, 3)
            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function ShiftMembersColumnConfig(shifts) {
    let rowData = [];
    if (shifts && shifts.length > 0) {
        shifts.forEach((shift) => {
            const row = {
                id: shift.id,
                data: shift,
                name: shift.name,
                employeeDetails: ShiftUtils.getEmployeeDetailsConfig(shift, 3)
            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function AssignMembersColumnConfig(members, shift, onActionButtonClick, isHasPermissioToDelete) {
    let rowData = [];
    if (members && members.length > 0) {
        members.forEach((member) => {
            const row = {
                id: member.userId,
                data: member,
                name: `${member.firstName} ${member.lastName}`,
                rowButtons: (!shift.applicableTo && isHasPermissioToDelete) ? [{title: "Delete", className: 'p-0 text-app fw-m text-underline', onClick: (data) => {onActionButtonClick("delete", data)}}] : []
            };
            rowData.push(row);
        });
    }
    return rowData;
}

export function getStatutoryGiroStatusText(employee) {
    let statusText = CONSTANTS.EMPTY_STRING;
        statusText = `<div class="row flex-wrap">
        <div class="row">EPF Giro - 
        <div class="row fs-m  pt-xs pb-xs pl-s pr-s border-radius-s ${employee?.epfGiroGenerated ? "data-grid-badge-color-6" : "data-grid-badge-color-4"} mb-s" style="width: auto;">
            <div class=" fs-r text-align-left  display-block " style="overflow-wrap: break-word; ">${employee?.epfGiroGenerated ? "Generated":"Not Generated"}</div>
        </div>
        </div>
        <div class="row">SOCSO Giro - 
        <div class="row fs-m  pt-xs pb-xs pl-s pr-s border-radius-s ${employee?.socsoGiroGenerated ? "data-grid-badge-color-6" : "data-grid-badge-color-4"} mb-s" style="width: auto;">
            <div class=" fs-r text-align-left  display-block " style="overflow-wrap: break-word; ">${employee?.socsoGiroGenerated ? "Generated":"Not Generated"}</div>
        </div>
        </div>
        <div class="row">MTD Giro - 
        <div class="row fs-m  pt-xs pb-xs pl-s pr-s border-radius-s ${employee?.incomeTaxGiroGenerated ? "data-grid-badge-color-6" : "data-grid-badge-color-4"} mb-s" style="width: auto;">
            <div class=" fs-r text-align-left  display-block " style="overflow-wrap: break-word; ">${employee?.incomeTaxGiroGenerated ? "Generated":"Not Generated"}</div>
        </div>
        </div>
        </div>`
    return statusText;
}

export function getModuleList(customField) {
    return `<div class="row flex-wrap">${customField['mappedWith'].map((f, i) =>`<div class="fs-m  p-v-xs p-h-s mr-s border-radius-s ${getModuleBadgeColor(f)} mb-s fs-s" style="width: fit-content;justify-content:flex-start; padding-top:3px" >${getModuleName(f)}</div>`).join('')}</div>`;

}

export function getModuleName(m) {
    switch (m) {
        case "employee_details":
            return "Employee Details"
        case "payrun":
            return "Payrun";
        case "payschedule":
            return "Payschedule";
        case "compOff":
                return "Compensatory Off";        
        default:
            return CONSTANTS.EMPTY_STRING;
    }
}

export function getModuleBadgeColor(m) {
    switch (m) {
        case "employee_details":
            return "data-grid-badge-color-6"
        case "payrun":
            return "data-grid-badge-color-4";
        case "payschedule":
            return "data-grid-badge-color-2";    
        default:
            return "data-grid-badge-color-6";
    }
}

export function updateWithExtraColumnConfigsValues(row, payrun, configData) {
    configData.forEach((c) =>{
        switch (c.key) {
            case "location":
                if(c.isActive) {
                    row[`${c.label}`] = !Utility.isEmpty(payrun.location) ? [payrun.location] : [] ;
                }
                break;
            case "custom_field":
                row = PayrollManager.updateCustomFieldValues(payrun, c, row);
                break;        
            default:
                break;
        }
    })
    return row;
}
export function getColumnById(columns, key) {
    return columns.find(
        (column) => (column.id ? column.id : column.name) === key
      )
}

export function updateWithExtraColumnConfigsValuesForEmployeeList(row, employee, configData) {
    configData.forEach((c) =>{
        switch (c.key) {
            case "location":
                if(c.isActive) {
                    row[`${c.label}`] = [employee.locationValue];
                }
                break;
            case "custom_field":
                row = EmployeeListService.updateCustomFieldValuesForEmployee(employee, c, row);
                break;        
            default:
                break;
        }
    })
    return row;
}


export function initializedCOmpoffsColumnConfig(compOffs,functionConfig,tenantDetails,customFields, usersMapValues) {
    let rowData = [];

    var today = moment()
    
    const { isLocationActive, locationLabel } = getLocationValueAndLabel(tenantDetails);
    if (compOffs && compOffs.length > 0) {
        compOffs.forEach((compoff, index) => {
            var daysLeft = moment(compoff.expiryDate, CONSTANTS.YYYYMMDD).diff(moment(),'days')
            let row = {
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.NAME] : compoff.workingHolidayFrom,
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.COMP_OFF_FOR] : compoff.isForAllUsers ? "All" : getUsersNames(compoff.users, usersMapValues),
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.WORKING_HOLIDAY] : compoff.workingHolidayFrom,
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.EXPIRY_MODE] : compoff.isExpiryNumOfDays ? "No. of Days" : "Date",
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.EXPIRY_AT] : compoff.expiryDate,
                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.DESCRIPTION] : compoff.description,
                // [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.STATUS] : ((moment(compoff.expiryDate).isBefore(today)) && !(moment(compoff.expiryDate).isSame(moment()))) ? "Expired" : "Active",

                [COLUMN_CODE.PEOPLE_MANAGE_COMP_OFF.STATUS] : daysLeft >= 0 ? "Active" : "Expired",
                ...compoff
            };
            const configData = [
                { key: "location",isActive: isLocationActive,label : locationLabel},
                { key : "custom_field",customFields: customFields}
            ];
            
            row = updateWithExtraColumnConfigsValuesForCompOff(row, compoff, configData);
            rowData.push(row);
        });
    }
    return rowData;
}

export function updateWithExtraColumnConfigsValuesForCompOff(row, compoff, configData) {
    configData.forEach((c) =>{
        switch (c.key) {
            case "location":
                if(c.isActive) {
                    row[`location`] = !Utility.isEmpty(compoff.location) ? [parseInt(compoff.location)] : [] ;
                }
                break;
            case "custom_field":
                row = updateCustomFieldValuesFormCompoffs(compoff, c, row);
                break;        
            default:
                break;
        }
    })
    return row;
}

export function updateCustomFieldValuesFormCompoffs(values, customFieldsData, group) {
    const { customFields } = customFieldsData || [];
    const customFieldFormValues = values?.customFieldsData || [];
    customFields?.forEach((c) => {
        const formValues = customFieldFormValues.find((x) => x.fieldId === c.id);
        if(!Utility.isEmptyObject(formValues)) {
            switch (c.type) {
                case "text":
                    if(formValues?.stringValue) {
                        group[c.id] = formValues?.stringValue;
                    }
                    break;
                case "multiselect":
                    group[c.id] = formValues?.optionValues;
                    break;
                case "number":
                    group[c.id] = formValues?.numberValue;
                    break;
                case "date":
                    if (formValues.stringValue) {
                        const date = moment(formValues.stringValue).toDate();                        
                        group[c.id] = Utility.isValidDate(date) ? reverseTimezoneOffset(date) : "";
                    } else {
                        const date = moment(formValues?.fieldValue ? formValues.fieldValue[0] : "").toDate()
                        group[c.id] = Utility.isValidDate(date) ? reverseTimezoneOffset(date) : "";
                    }
                    break;
                default:
                    if(formValues?.fieldValue) {
                        group[c.id] = formValues?.fieldValue[0];
                    }
                    break;
            }
        }
    });
    return group;
}

export function getUsersNames(iamUserIds, usersMap) {
    let text = `<div><div class="row flex-wrap">`
    if(usersMap.size > 0 && iamUserIds.length > 1) {
        for(let i = 0; i < 1; i++) {
            const userName = getNamefromMap(iamUserIds[i],usersMap)
            if(!Utility.isEmpty(userName)) {
                text += `<div class="fs-m  p-v-xs p-h-s mr-s border-radius-s fs-s data-grid-badge-color-6" style="width: fit-content;justify-content:flex-start; padding-top:3px" >${userName}</div>`
            }
        }
        const remainingUsers = iamUserIds.length - 1;
        text +=`<div class="fw-m text-app cursor-hand" onclick="window.openUsersList('${Utility.encodeJSON(iamUserIds)}')"><u>+${remainingUsers === 1 ? remainingUsers + " Other" : remainingUsers + " Others"}</u></div>`
    } else if(usersMap.size > 0) {

        return `<div><div class="column flex-wrap">${iamUserIds.map((f, i) =>`<div class="fs-m  p-v-xs p-h-s mr-s border-radius-s mb-s fs-s ${!Utility.isEmpty(usersMap.get(f)) ? "data-grid-badge-color-6" : ""}" style="width: fit-content;justify-content:flex-start; padding-top:3px" >${getNamefromMap(f,usersMap)}</div>`).join('')}</div></div>`;   
            
    }
    text += `</div></div>`
    return text
}

export function getNamefromMap(f,usersMap) {
    const users = usersMap.get(f);
    if(!Utility.isEmpty(users)) {
        return `${users.firstName} ${users.lastName}`
    }
    return CONSTANTS.EMPTY_STRING;
}
export function prepareRowDataForm16(rows=[],config) {
    let rowData = [];
    rows.forEach(row=>{
        const msg =  getFilterForm16(row.documents)?.reason
        const user = {
            ...row,
            name: msg ?  `<div class="d-flex align-items-center">${row.firstName} ${row.lastName}<span class="ml-s info_error_icon" data-tip="${msg}"><img class="ic-s" style="margin-top:1px;" src= ${ic_info_warning} /></span></div>`:`${row.firstName} ${row.lastName}`,
            form16Status: [getFilterForm16(row.documents)?.status || ''],
            rowContextMenu: getDocumentList(row.documents,config)
        }
        rowData.push(user);
    })
    return rowData
}
function getFilterForm16(documents) {
    const filterStr = `Form-16 ${moment().format("M") > 3 ? moment().subtract('year',1).format("YYYY"):moment().subtract('year',2).format("YYYY")}`
    const newDoc = documents?.find(doc=>doc?.name?.includes(filterStr));
    return {
        status: !Utility.isEmpty(newDoc?.docStatus) ? newDoc?.docStatus === 'success' ? 'true' : 'false' : '',
        reason: newDoc?.reason
    }
     
}
function getDocumentList(documents,config) {
    let list = [];
    const filterStr = `Form-16 ${moment().format("M") > 3 ? moment().subtract('year',1).format("YYYY"):moment().subtract('year',2).format("YYYY")}`
    const newDoc = documents?.filter(doc=>doc?.name?.includes(filterStr)) || []
    const generate = {
        title: "Generate",
        icon: DKIcons.ic_export,
        className:" text-app fw-m text-underline",
        onClick: (doc) => {
            config?.refresh(doc, -1,false);
        },
    };
    newDoc?.forEach((doc,index)=>{
        const downloadSigned = {
            title: doc.name,
            icon: ic_download,
            className:" text-app fw-m text-underline",
            onClick: (doc) => {
                config?.downloadSigned(doc, index);
            },
        };
        if(!Utility.isEmpty(doc.path)) {
            list.push(downloadSigned)
        }
        
        const refresh = {
            title: "Regenerate",
            icon: ic_replay,
            className:" text-app fw-m text-underline",
            onClick: (doc) => {
                config?.refresh(doc, index,true);
            },
        };
        
        
        if(!Utility.isEmpty(doc.docStatus)) {
            list.push(refresh)
        } else {
            list.push(generate)
        }
       
        
    })
    if(Utility.isEmpty(newDoc)) {
        list.push(generate)
    }
    return list
}
export function goalsDataUpdateBeforeDisplay(rowData) {
    let rowContext =[]
     rowData.map(row=>{
        rowContext.push({
            ...row,
            originalRow: deepClone(row),
            priority: [row.priority],
            applicableToCount: getApplicableToCountButton(row)
        })
    })
    return rowContext
}
function getApplicableToCountButton(row) {
    let applicableToColumn = ``;
    if(!Utility.isEmpty(row?.applicability?.designation)) {
        applicableToColumn = `<b>Designation:</b> <text class="text-app fs-r fw-m text-underline pl-s">${row?.applicability?.designation}</text>`
    } else if(!Utility.isEmpty(row?.applicability?.teamId)) {
        applicableToColumn = `<b>Team:</b><text class="text-app fs-r fw-m text-underline pl-s">${row?.applicability?.teamName}</text>`
    } else {
        applicableToColumn = (row?.applicability?.users?.length>0) ? 
        `<text class="text-app fs-r fw-m text-underline">${row.applicability?.users?.length} ${row?.applicability?.users?.length>1 ?"users":"user"}</text>`
        :``
    }
    
    return (
        `<div class="row p-h-m">
        <div class="d-flex dk-button-hover cursor-hand" onclick="window.viewApplicableTo('${Utility.encodeJSON(row)}')">
            ${applicableToColumn}
        </div>
        </div>`
    );
}

export function getAppraisalCycleRowConfig(rowData) {
    let rowContext =[]
     rowData.forEach(row=>{
        rowContext.push({
            ...row,
            status: [row?.active ? row.active.toString(): 'false'],
            
            startDate: Utility.formatDate(moment(row.startDate, FORMAT.DDMMYYYY), FORMAT.YYYYMMDD, ""),
            dueDate: Utility.formatDate(moment(row.endDate, FORMAT.DDMMYYYY), FORMAT.YYYYMMDD, ""),

            selfAssessmentProgress: getProgress(row,'appraiseeProgressCount'),
            appraisalProgress: getProgress(row,'appraiserProgressCount'),
            data: row
        })
    })
    return rowContext
}
function getProgressPercent(row, progressFor) {
    const totalAppraisees = row['totalAppraisees'] ? parseFloat(row['totalAppraisees']) : 0;
    const progress = row[progressFor] ? parseFloat(row[progressFor]) : 0;
    let percent = 0;
    try {
        percent = progress ? (totalAppraisees ? ((progress / totalAppraisees) * 100) : 0) : 0;
        percent = Math.round(percent);
    } catch (e) {
        percent = 0;
    }
    return percent
}
export function getProgress(row,progressFor) {
    const processed = getProgressPercent(row,progressFor);
    const remaining = Math.round(100-processed);
    return `<div class="">`+
                `<b class="fs-r text-gray">${processed}%</b>`+
                `<div class="d-flex">`+
                `<div class="bg-app"style="width:${processed}%;height:3px;">`+
                `</div>`+
                `<div style="width:${remaining}%;height:3px;background: lightgrey;">`+
                `</div>`+
                `</div>`+
            `</div>`
}

export function expenseLimitPolicyListColumnConfig(data) {
  const rowData = [];
  if(data?.content?.length) {
    data.content.forEach(f => {
      const row = {
        [COLUMN_CODE.PEOPLE_EXPENSE_LIMIT.CATEGORIES] : getCategoryNames(f.expenseCategoryLimits),
        [COLUMN_CODE.PEOPLE_EXPENSE_LIMIT.CATEGORY_LIMIT] : f.expenseCategoryLimit,
        [COLUMN_CODE.PEOPLE_EXPENSE_LIMIT.ONE_TIME_EXPENSE_LIMIT] : f.oneTimeExpenseLimit,
        [COLUMN_CODE.PEOPLE_EXPENSE_LIMIT.EXPENSE_LIMIT_MONTHLY] : f.monthlyLimit,
        [COLUMN_CODE.PEOPLE_EXPENSE_LIMIT.EXPENSE_LIMIT_YEARLY] : f.yearlyLimit,
        ...f,
      }
      rowData.push(row);
    })
  }
  return rowData;
}

export function getCategoryNames(expenseCategories) {
  let text = `<div><div class="row flex-wrap">`
  if(expenseCategories.length > 1) {
      for(let i = 0; i < 1; i++) {
          const categoryData = expenseCategories[i]?.expenseCategoryId;
          if(!Utility.isEmpty(categoryData)) {
              text += `<div class="fs-m  p-v-xs p-h-s mr-s border-radius-s fs-s data-grid-badge-color-6" style="width: fit-content;justify-content:flex-start; padding-top:3px" >${categoryData?.name}</div>`
          }
      }
      const remainingCategory = expenseCategories.length - 1;
      text +=`<div class="fw-m text-app cursor-hand" onclick="window.openCategoryList('${Utility.encodeJSON(expenseCategories)}')"><u>+${remainingCategory === 1 ? remainingCategory + " Other" : remainingCategory + " Others"}</u></div>`
  } else if(expenseCategories.length > 0) {

      return `<div><div class="column flex-wrap">${expenseCategories.map((e, i) =>`<div class="fs-m  p-v-xs p-h-s mr-s border-radius-s mb-s fs-s ${!Utility.isEmpty(e) ? "data-grid-badge-color-6" : ""}" style="width: fit-content;justify-content:flex-start; padding-top:3px" >${getCategoryNamefromMap(e)}</div>`).join('')}</div></div>`;   
          
  }
  text += `</div></div>`
  return text
}

export function getCategoryNamefromMap(e) {
  const category = e.expenseCategoryId;
  if(!Utility.isEmpty(category)) {
      return `${category.name}`
  }
  return CONSTANTS.EMPTY_STRING;
}
function getApplicableEmployeesInPayrun(row) {
    let applicableToColumn = ``;
    applicableToColumn = (row?.employeeDetails?.length > 0) ?
        `<text class="text-app fs-r fw-m text-underline">${row.employeeDetails?.length} ${row?.employeeDetails?.length > 1 ? "Employees" : "Employee"}</text>`
        : ``
    return (
        `<div class="row p-h-m">
        <div class="d-flex dk-button-hover cursor-hand" onclick="window.viewApplicableTo('${Utility.encodeJSON(row)}')">
            ${applicableToColumn}
        </div>
        </div>`
    );
}

function getContextMenuForIRASSubmission(employee,formName, functionConfig) {
  let action = []
  let formStatus = employee?.formStatus;
    let isSubmitted = false;
    if(!Utility.isEmptyObject(formStatus)) {
        let index = formStatus.findIndex(x=> x.type === formName);
        if(index != -1) {
            const formConfig = formStatus[index];
            isSubmitted = formConfig.isSubmitted;
        }
        if(isSubmitted) {
          action.push({
            title: "View Amendment Process",
            icon: ic_visibility,
            onClick: () => {
              functionConfig.routeForAppendment();
  
            }
        })
      }
    }

  return action
}

function getSubmittedIcon (element,formName, view) {
  let formStatus = element?.formStatus;
  let isSubmitted = false;
    if(!Utility.isEmptyObject(formStatus) && view === "IRAS_SUBMISSION") {
        let index = formStatus.findIndex(x=> x.type === formName);
        if(index != -1) {
            const formConfig = formStatus[index];
            isSubmitted = formConfig.isSubmitted;
        }
        if(isSubmitted) {
          const msg = "This record has already been submitted to <b>IRAS</b>.<br> Check <b>action menu</b> to view <b>amendment process</b> if any."
          return `<div class="d-flex align-items-center">${element.employeeId}<span class="ml-s info_error_icon" data-tip="${msg}"><img class="ic-s" style="margin-top:1px;" src= ${ic_info_warning} /></span></div>`
        }
    }
  return element.employeeId;
}
